export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: number; output: `${number}`; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string; }
  StringMoney: { input: any; output: any; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: { uri: string, name: string, type: string }; output: object; }
};

/** An enumeration. */
export enum AcademyBadgeRarityChoices {
  /** Común */
  Common = 'COMMON',
  /** Épico */
  Epic = 'EPIC',
  /** Legendario */
  Legendary = 'LEGENDARY',
  /** Raro */
  Rare = 'RARE'
}

/** An enumeration. */
export enum AcademyBadgeTriggerTypeChoices {
  /** Cantidad de cursos completados */
  CoursesCompletedCount = 'COURSES_COMPLETED_COUNT',
  /** Curso completado */
  CourseCompleted = 'COURSE_COMPLETED',
  /** Primer curso completado */
  FirstCourseCompleted = 'FIRST_COURSE_COMPLETED',
  /** Cantidad de lecciones completadas */
  LessonsCompletedCount = 'LESSONS_COMPLETED_COUNT',
  /** Otorgado manualmente */
  Manual = 'MANUAL',
  /** Nivel de habilidad alcanzado */
  SkillLevelReached = 'SKILL_LEVEL_REACHED',
  /** Días de racha de aprendizaje */
  StreakDays = 'STREAK_DAYS'
}

/** An enumeration. */
export enum AcademyCourseDifficultyChoices {
  /** Avanzado */
  Advanced = 'ADVANCED',
  /** Principiante */
  Beginner = 'BEGINNER',
  /** Intermedio */
  Intermediate = 'INTERMEDIATE'
}

/** An enumeration. */
export enum AcademyCourseStatusChoices {
  /** Archivada */
  Archived = 'ARCHIVED',
  /** Borrador */
  Draft = 'DRAFT',
  /** Publicado */
  Published = 'PUBLISHED'
}

/** An enumeration. */
export enum AcademyQuizSubmissionStatusChoices {
  /** Aprobada */
  Approved = 'APPROVED',
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Eliminado */
  Deleted = 'DELETED',
  /** En revisión */
  InReview = 'IN_REVIEW',
  /** Revisión pendiente */
  Pending = 'PENDING',
  /** Rechazado */
  Rejected = 'REJECTED'
}

export type AcceptAfiliateProgramPostulationInput = {
  afiliateProgramPostulationId: Scalars['ID']['input'];
  discountCode: Scalars['String']['input'];
  newProgramId: Scalars['ID']['input'];
};

export type AccessTokenInput = {
  accessToken: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  expiresIn: Scalars['Int']['input'];
  issuedAt: Scalars['Int']['input'];
  permissions: Array<Scalars['String']['input']>;
  platformUserId?: InputMaybe<Scalars['String']['input']>;
  provider: PlatformCodeEnum;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresIn?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum AccountDeletionBlockerCode {
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  AffiliateProgram = 'AFFILIATE_PROGRAM',
  PendingWithdrawal = 'PENDING_WITHDRAWAL',
  UnpaidCommissions = 'UNPAID_COMMISSIONS',
  WalletBalance = 'WALLET_BALANCE',
  WorkspaceOwner = 'WORKSPACE_OWNER',
  WorkOrderInProgress = 'WORK_ORDER_IN_PROGRESS'
}

/** An enumeration. */
export enum AccountDeletionReason {
  NotUseful = 'NOT_USEFUL',
  NoCampaigns = 'NO_CAMPAIGNS',
  Other = 'OTHER',
  OtherAccount = 'OTHER_ACCOUNT',
  Privacy = 'PRIVACY',
  TooManyNotifications = 'TOO_MANY_NOTIFICATIONS'
}

/**
 * Ad platforms whose clicks a guest session keeps. Values are the
 * platforms' `PlatformCodeEnum` codes.
 */
export enum AdPlatform {
  Meta = 'META',
  TikTok = 'TIK_TOK'
}

export type AddAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  areaId: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  defaultAddress?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  placeNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  route: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddAddressV2Input = {
  googlePlaceId: Scalars['ID']['input'];
  placeNumber?: InputMaybe<Scalars['String']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type AddToFavoriteInput = {
  brandId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AddToProgramAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  areaId: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  route: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddToProgramBankAccountInput = {
  accountNumber: Scalars['String']['input'];
  bank: Scalars['ID']['input'];
  /** @deprecated Use `bankAccountIdentifierInput`, which carries the type. */
  bankAccountIdentifier?: InputMaybe<Scalars['String']['input']>;
  bankAccountIdentifierInput?: InputMaybe<IdentificatorInput>;
  bankAccountType: BankAccountEnum;
};

export type AddToProgramGeneralDataInput = {
  address: AddToProgramAddressInput;
  birthDate: Scalars['Date']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['ID']['input'];
  /** @deprecated Use `identifierInput`, which carries the type. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierInput?: InputMaybe<IdentificatorInput>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type AddToProgramInputType = {
  affiliateCode: Scalars['String']['input'];
  bankAccount?: InputMaybe<AddToProgramBankAccountInput>;
  profile: AddToProgramGeneralDataInput;
};

export type AddUserNicheInput = {
  dateUploaded?: InputMaybe<Scalars['Date']['input']>;
  kind: UserNicheKind;
  link?: InputMaybe<Scalars['String']['input']>;
  multipartUploadId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nicheId: Scalars['ID']['input'];
  postLink?: InputMaybe<Scalars['String']['input']>;
  socialNetworkUsername?: InputMaybe<Scalars['String']['input']>;
};

export type AfiliateProgramInput = {
  brandId: Scalars['String']['input'];
  collections: Array<Scalars['String']['input']>;
  combinesWithOrderDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  combinesWithProductDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  combinesWithShippingDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  conditions: Array<Scalars['String']['input']>;
  contentElaboration: ContentElaborationEnum;
  contents: Array<ProgramContentInput>;
  discountPercentage: Scalars['Decimal']['input'];
  fixedPayment: MoneyInput;
  name: Scalars['String']['input'];
  objective: CampaignObjectiveEnum;
  priceProducts: Array<PriceProductInput>;
  productPaymentOption: ProductPaymentOption;
  productToPromote?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  since: Scalars['Date']['input'];
  until?: InputMaybe<Scalars['Date']['input']>;
  variablePaymentType?: InputMaybe<VariablePaymentType>;
  variablePercentagePayment: Scalars['Decimal']['input'];
  welcomeGiftCard: MoneyInput;
  welcomeProducts: Array<Scalars['ID']['input']>;
};

/** An enumeration. */
export enum AfiliateProgramUserSaleInvalidReason {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  ManuallyInvalidated = 'MANUALLY_INVALIDATED',
  PendingPayment = 'PENDING_PAYMENT',
  Refunded = 'REFUNDED',
  Voided = 'VOIDED'
}

/** An enumeration. */
export enum AfiliateUserStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  PreSelection = 'PRE_SELECTION',
  Rejected = 'REJECTED',
  Terminated = 'TERMINATED'
}

/**
 * Identifies which agent definition a session talks to.
 *
 * Values are code artifacts, not admin-created data: each one must have a
 * matching `BaseAgentDefinition` registered in `agents.runtime.registry`.
 *
 * The campaign creator is three agents, not one, because the three kinds of
 * campaign are three different things to build. A UGC campaign always produces Meta
 * ads; a MeliClips campaign always produces a Mercado Clip; an organic campaign can
 * produce several formats and is the only one that asks which. The type is chosen
 * when the chat opens, and each creator knows from birth what it is building.
 *
 * The router that used to pick the type by asking (`CAMPAIGN_CREATOR_ROUTER`) is
 * gone with the interview it belonged to; sessions that used it are archived.
 *
 */
export enum AgentKey {
  CampaignCreatorMeliclips = 'CAMPAIGN_CREATOR_MELICLIPS',
  CampaignCreatorOrganic = 'CAMPAIGN_CREATOR_ORGANIC',
  CampaignCreatorUgc = 'CAMPAIGN_CREATOR_UGC'
}

export type ApplicationAfiliateProgramPostulationInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  comments: Scalars['String']['input'];
  commune: Scalars['String']['input'];
  email: Scalars['String']['input'];
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
  tiktokUsername?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum AspectsToImproveEnum {
  BriefUnderstanding = 'BRIEF_UNDERSTANDING',
  Speed = 'SPEED',
  Storytelling = 'STORYTELLING',
  Versatility = 'VERSATILITY',
  VideoQuality = 'VIDEO_QUALITY'
}

export type AssociatePostInput = {
  postLink: Scalars['String']['input'];
  uploadedAt?: InputMaybe<Scalars['Date']['input']>;
  uploadedBy?: InputMaybe<ContentRequirementUploaderEnum>;
  workOrderDetailId: Scalars['String']['input'];
};

export type AssociateQuizSubmissionPostInput = {
  postLink: Scalars['String']['input'];
  quizSubmissionId: Scalars['ID']['input'];
};

export type AuthorizationTokenInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  grantType: Scalars['String']['input'];
  provider: PlatformCodeEnum;
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type BankAccountEditInput = {
  accountType: BankAccountEnum;
  bank: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `identificatorInput`, which carries the type. */
  identificator?: InputMaybe<Scalars['String']['input']>;
  identificatorInput?: InputMaybe<IdentificatorInput>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

/** An enumeration. */
export enum BankAccountEnum {
  CheckingAccount = 'CHECKING_ACCOUNT',
  DebitAccount = 'DEBIT_ACCOUNT',
  SavingsAccount = 'SAVINGS_ACCOUNT'
}

export type BankAccountInput = {
  accountType: BankAccountEnum;
  bank: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `identificatorInput`, which carries the type. */
  identificator?: InputMaybe<Scalars['String']['input']>;
  identificatorInput?: InputMaybe<IdentificatorInput>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

export type BrandAttributesOnboardingInputType = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  industry: IndustryEnum;
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One image of a new graphic, in order: a confirmed `BRAND_GRAPHIC_IMAGE`
 * multipart upload and the format it is cut for.
 */
export type BrandGraphicImageEntryInput = {
  formatId: Scalars['ID']['input'];
  multipartUploadId: Scalars['ID']['input'];
};

export type BrandInputType = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
  industry: IndustryEnum;
  name: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

/**
 * The KPI tiles the brand-analytics surface always returns, in order.
 *
 * The values double as the identity each tile is looked up by on the client,
 * so they are part of the API contract: renaming one silently blanks a tile.
 *
 */
export enum BrandKpiKeyEnum {
  EngagementRate = 'ENGAGEMENT_RATE',
  Followers = 'FOLLOWERS',
  Impressions = 'IMPRESSIONS',
  Interactions = 'INTERACTIONS',
  Reach = 'REACH'
}

export type BrandOnboardingInputType = {
  brand: BrandAttributesOnboardingInputType;
};

/** An enumeration. */
export enum BudgetType {
  Fixed = 'FIXED',
  Off = 'OFF',
  Quote = 'QUOTE'
}

export type BulkAddToFavoriteInput = {
  brandId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type BulkRemoveFromFavoriteInput = {
  brandId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum BusinessStage {
  BrandConsolidation = 'BRAND_CONSOLIDATION',
  Expansion = 'EXPANSION',
  FirstSales = 'FIRST_SALES',
  Scalability = 'SCALABILITY',
  Validation = 'VALIDATION'
}

/** An enumeration. */
export enum BusinessType {
  Dropshipping = 'DROPSHIPPING',
  Ecommerce = 'ECOMMERCE',
  EcommerceStore = 'ECOMMERCE_STORE',
  FoodStore = 'FOOD_STORE',
  Service = 'SERVICE',
  Store = 'STORE'
}

/**
 * Input type para guardar o actualizar un borrador de campaña.
 * draft_data debe contener la estructura del formulario React:
 * {
 *   "stepOne": {...},  # generalInformation
 *   "stepTwo": {...},  # campaignObject
 *   "stepThree": {...},  # requirements
 *   "stepFour": {...},  # payments
 *   "stepFive": {...},  # creators
 *   "currentStep": 1  # Paso actual donde quedó el usuario
 * }
 */
export type CampaignDraftInputType = {
  brandId: Scalars['ID']['input'];
  draftData: Scalars['JSONString']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  medias: Array<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignGiftCardInput = {
  amount: MoneyInput;
  condition: Scalars['String']['input'];
};

export enum CampaignGroupKind {
  CanPostulate = 'CAN_POSTULATE',
  ForYou = 'FOR_YOU',
  Industry = 'INDUSTRY',
  Niche = 'NICHE',
  OpenToAll = 'OPEN_TO_ALL'
}

export type CampaignInfluencerCharacterizationTypeInput = {
  /** Ids of the areas creators must live in, at any depth. They must belong to the brand's country. */
  areas: Array<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  followers: Array<Scalars['String']['input']>;
  genders: Array<Scalars['String']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  niches: Array<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignInputType = {
  brandId: Scalars['String']['input'];
  budgetType: BudgetType;
  campaignGiftCard: CampaignGiftCardInput;
  campaignInfluencerCharacterization: CampaignInfluencerCharacterizationTypeInput;
  campaignMedias: Array<CampaignMediaInputType>;
  campaignProducts: Array<CampaignProductInputType>;
  campaignType?: InputMaybe<CampaignTypeEnum>;
  contentRequirements: Array<ContentRequirementInputType>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  /** Required unless the campaign is private, which never closes. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  maxBudget: MoneyInput;
  minBudget: MoneyInput;
  object?: InputMaybe<CampaignObject>;
  objective: CampaignObjectiveEnum;
  preUploadRequirementsEnum: Array<PreUploadRequirementEnum>;
  preUploadRequirementsId: Array<Scalars['String']['input']>;
  priceProducts: Array<CampaignPriceProductInputType>;
  private: Scalars['Boolean']['input'];
  questions: Array<CampaignQuestionInputType>;
  rightOfUse?: InputMaybe<RightOfUse>;
  rightOfUseMonths?: InputMaybe<Scalars['Int']['input']>;
  /** The campaign opens when it is published; send a day only to delay the opening to the start of that day. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timeInProfile?: InputMaybe<RightOfUse>;
  timeInProfileMonths?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** An enumeration. */
export enum CampaignInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type CampaignMediaInputType = {
  media: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

/** An enumeration. */
export enum CampaignObject {
  Brand = 'BRAND',
  Event = 'EVENT',
  Product = 'PRODUCT'
}

/** An enumeration. */
export enum CampaignObjectiveEnum {
  BuildCustomerLoyalty = 'BUILD_CUSTOMER_LOYALTY',
  CloseSales = 'CLOSE_SALES',
  GenerateInterest = 'GENERATE_INTEREST',
  IncreaseBrandAwareness = 'INCREASE_BRAND_AWARENESS'
}

export type CampaignPriceProductInputType = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CampaignProductInputType = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  relationsId: Array<Scalars['String']['input']>;
};

export type CampaignQuestionInputType = {
  question: Scalars['String']['input'];
};

/** An enumeration. */
export enum CampaignStatus {
  Finished = 'FINISHED',
  Open = 'OPEN'
}

/** An enumeration. */
export enum CampaignTemplateEnum {
  Affiliates = 'AFFILIATES',
  Cold = 'COLD',
  FullFunnel = 'FULL_FUNNEL',
  Hot = 'HOT',
  LiveSelling = 'LIVE_SELLING',
  MicroInfluencerSequence = 'MICRO_INFLUENCER_SEQUENCE',
  NotInfluencerPlacements = 'NOT_INFLUENCER_PLACEMENTS',
  PostStory = 'POST_STORY',
  Swarm = 'SWARM',
  UgcClips = 'UGC_CLIPS',
  ViralAds = 'VIRAL_ADS',
  ViralAdsTikTok = 'VIRAL_ADS_TIK_TOK',
  ViralCollaboration = 'VIRAL_COLLABORATION',
  Warm = 'WARM'
}

/** An enumeration. */
export enum CampaignTypeEnum {
  Affiliates = 'AFFILIATES',
  Melicliips = 'MELICLIIPS',
  Organic = 'ORGANIC',
  Ugc = 'UGC',
  Viral = 'VIRAL'
}

/**
 * The three buckets analytics reasons about.
 *
 * `campaign_type` alone cannot express them: "organic" is a *residual* — every
 * campaign that is not UGC and not clips, including the legacy rows whose type
 * is NULL — so `campaign_type__in` would silently drop untyped campaigns from
 * the bucket the report counts them in.
 */
export enum CampaignTypeGroup {
  Clips = 'CLIPS',
  Organic = 'ORGANIC',
  Ugc = 'UGC'
}

export type CancelWorkOrderInput = {
  reason: WorkOrderCancelReasonEnum;
  workOrderId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum CancellationReasonEnum {
  BrandPerformance = 'BRAND_PERFORMANCE',
  ContentQuality = 'CONTENT_QUALITY',
  Other = 'OTHER',
  WrongCreators = 'WRONG_CREATORS'
}

export type CancellationReasonInput = {
  comments: Scalars['String']['input'];
  reason: CancellationReasonEnum;
};

export type ChangeDiscountCodeInputType = {
  afiliateProgramUserId: Scalars['ID']['input'];
  newCode: Scalars['String']['input'];
};

export type ChatInputType = {
  brandId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ChatMessageInputType = {
  chatId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  sentByBrand: Scalars['Boolean']['input'];
  upload?: InputMaybe<Scalars['Upload']['input']>;
};

export enum ClassifierFacet {
  Campaign = 'CAMPAIGN',
  Creators = 'CREATORS',
  CreatorTier = 'CREATOR_TIER',
  Format = 'FORMAT',
  Platform = 'PLATFORM',
  Rights = 'RIGHTS'
}

/** An enumeration. */
export enum ClothingSizeEnum {
  L = 'L',
  M = 'M',
  S = 'S',
  Xl = 'XL',
  Xs = 'XS',
  Xxl = 'XXL',
  Xxs = 'XXS',
  Xxxl = 'XXXL'
}

/** An enumeration. */
export enum CommunityLikeTarget {
  Comment = 'COMMENT',
  Post = 'POST'
}

/** An enumeration. */
export enum CommunityPostFeaturedIcon {
  Calendar = 'CALENDAR',
  Gift = 'GIFT',
  Lightbulb = 'LIGHTBULB',
  Megaphone = 'MEGAPHONE',
  Sparkles = 'SPARKLES',
  Star = 'STAR',
  TrendingUp = 'TRENDING_UP'
}

/**
 * One entry of an ordered `CommunityPost` media gallery.
 *
 * - `id` alone: keep the existing item as-is.
 * - `id` + `thumbnailMultipartUploadId`: keep the existing item, replacing
 *   its thumbnail (the existing item must be a video).
 * - `multipartUploadId` alone: attach a new image -- the upload's purpose
 *   must be `COMMUNITY_POST_IMAGE`.
 * - `multipartUploadId` + `thumbnailMultipartUploadId`: attach a new video
 *   -- purposes `COMMUNITY_POST_VIDEO` / `COMMUNITY_POST_VIDEO_THUMBNAIL`.
 *
 * `thumbnailTimeSeconds` may only be set alongside
 * `thumbnailMultipartUploadId`: the second in the video the thumbnail frame
 * was captured at, left unset when the thumbnail is an uploaded image
 * instead of a captured frame.
 *
 * List-level semantics, enforced by the consuming command (graphene has no
 * `@oneOf` to validate "exactly one" at the schema layer):
 *
 * - the list argument omitted entirely -> the gallery is left untouched
 * - `[]` -> every existing item is deleted
 * - otherwise -> the list is the final gallery, in order; any item not
 *   referenced by an entry's `id` is deleted
 */
export type CommunityPostMediaEntryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  multipartUploadId?: InputMaybe<Scalars['ID']['input']>;
  thumbnailMultipartUploadId?: InputMaybe<Scalars['ID']['input']>;
  thumbnailTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Distinct name from `onboarding.BrandOnboardingInputType` -- GraphQL
 * type names are global, and reusing that name here would silently shadow
 * one of the two definitions in the schema's type map.
 */
export type CompleteBrandOnboardingBrandInputType = {
  countryId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  industry: IndustryEnum;
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteBrandOnboardingInputType = {
  brand: CompleteBrandOnboardingBrandInputType;
  payer?: InputMaybe<CompleteBrandOnboardingPayerInputType>;
  payerEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteBrandOnboardingPayerInputType = {
  legalName: Scalars['String']['input'];
  /** @deprecated Use `taxIdInput`, which carries the type. */
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdInput?: InputMaybe<IdentificatorInput>;
};

export type ConnectAccountInput = {
  accessToken: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  expiresIn: Scalars['Int']['input'];
  issuedAt: Scalars['Int']['input'];
  permissions: Array<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  user?: InputMaybe<UserObject>;
};

/** An enumeration. */
export enum ContentApprovalCreatorTierEnum {
  Macro = 'MACRO',
  Mega = 'MEGA',
  Micro = 'MICRO',
  Nano = 'NANO'
}

/** An enumeration. */
export enum ContentApprovalRightsBucketEnum {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Limited = 'LIMITED',
  Perpetual = 'PERPETUAL'
}

/** An enumeration. */
export enum ContentElaborationEnum {
  Free = 'FREE',
  Specification = 'SPECIFICATION'
}

export type ContentRequirementDateInput = {
  contentRequirementId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  reviewDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ContentRequirementInput = {
  additionalConditions?: InputMaybe<Array<Scalars['String']['input']>>;
  contentRequirementId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  hasReview: Scalars['Boolean']['input'];
  rightOfUse?: InputMaybe<RightOfUse>;
  rightOfUseMonths?: InputMaybe<Scalars['Int']['input']>;
  script: Scalars['String']['input'];
  sendContentDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ContentRequirementInputType = {
  collaborationAccounts: Array<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  hasReview: Scalars['Boolean']['input'];
  hashtags: Array<Scalars['String']['input']>;
  mentionedAccounts: Array<Scalars['String']['input']>;
  postTypeId: Scalars['String']['input'];
  preUploadRequirementsEnum: Array<PreUploadRequirementEnum>;
  preUploadRequirementsId: Array<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  references: Array<ReferenceInputType>;
  required: Scalars['Boolean']['input'];
  reviewDate?: InputMaybe<Scalars['Date']['input']>;
  template: ContentRequirementTemplate;
  uploader: ContentRequirementUploaderEnum;
};

/** An enumeration. */
export enum ContentRequirementTemplate {
  BeforeAfter = 'BEFORE_AFTER',
  Carousel = 'CAROUSEL',
  Demo = 'DEMO',
  Foodie = 'FOODIE',
  FullViral = 'FULL_VIRAL',
  Grwm = 'GRWM',
  Microinfluencer = 'MICROINFLUENCER',
  None = 'NONE',
  ProblemSolution = 'PROBLEM_SOLUTION',
  ProductLaunch = 'PRODUCT_LAUNCH',
  Review = 'REVIEW',
  SocialProofer = 'SOCIAL_PROOFER',
  SpecialOffer = 'SPECIAL_OFFER',
  Story = 'STORY',
  Tutorial = 'TUTORIAL',
  Unboxing = 'UNBOXING',
  UnboxingDemo = 'UNBOXING_DEMO',
  Video = 'VIDEO'
}

/** An enumeration. */
export enum ContentRequirementUploaderEnum {
  Ambassador = 'AMBASSADOR',
  Brand = 'BRAND'
}

export type CreateBrandGraphicInput = {
  /** Levels that see the graphic; empty means every level. */
  afiliateProgramIds: Array<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  images: Array<BrandGraphicImageEntryInput>;
  title: Scalars['String']['input'];
};

export type CreateCommunityPostInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandIds: Array<Scalars['ID']['input']>;
  featuredIcon?: InputMaybe<CommunityPostFeaturedIcon>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<CommunityPostMediaEntryInput>>;
  title: Scalars['String']['input'];
};

export type CreateEventInput = {
  appLabelId?: InputMaybe<Scalars['ID']['input']>;
  applicationMode?: InputMaybe<EventApplicationMode>;
  audienceAfiliateProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audienceAfiliateUserStatuses?: InputMaybe<Array<AfiliateUserStatus>>;
  audienceJoinedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ecommerceOfficeId?: InputMaybe<Scalars['ID']['input']>;
  endsAt: Scalars['DateTime']['input'];
  eventTypeId: Scalars['ID']['input'];
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type CreateEventTypeInput = {
  allowAdminInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  allowUserApplication?: InputMaybe<Scalars['Boolean']['input']>;
  appLabelId: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  defaultApplicationMode?: InputMaybe<Scalars['String']['input']>;
  defaultDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLessonQuizSubmissionInput = {
  lessonQuizId: Scalars['ID']['input'];
  multipartUploadId: Scalars['ID']['input'];
};

export type CreateWorkspaceCreatorInputType = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type CreatorRateInput = {
  amount: MoneyInput;
  postTypeId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum CreatorReportReasonEnum {
  LateDelivery = 'LATE_DELIVERY',
  NoContent = 'NO_CONTENT',
  Other = 'OTHER'
}

/** An enumeration. */
export enum CreatorSegmentEnum {
  Influencer = 'INFLUENCER',
  Modelo = 'MODELO',
  Promotora = 'PROMOTORA',
  Ugc = 'UGC'
}

/** An enumeration. */
export enum CustomerAwarenessLevelEnum {
  ProblemAware = 'PROBLEM_AWARE',
  ProblemUnaware = 'PROBLEM_UNAWARE',
  ProductAware = 'PRODUCT_AWARE',
  SalesStage = 'SALES_STAGE',
  SolutionAware = 'SOLUTION_AWARE'
}

/** An enumeration. */
export enum DeliveryFrecuencyOptions {
  Monthly = 'MONTHLY',
  OneOff = 'ONE_OFF',
  Weekly = 'WEEKLY'
}

export type DiscountCodeEntryInputType = {
  active: Scalars['Boolean']['input'];
  collectionIds: Array<Scalars['ID']['input']>;
  combinesWithOrderDiscounts: Scalars['Boolean']['input'];
  combinesWithProductDiscounts: Scalars['Boolean']['input'];
  combinesWithShippingDiscounts: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
};

/** An enumeration. */
export enum DraftUploadMediaType {
  Archive = 'ARCHIVE',
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Video = 'VIDEO'
}

export type EditBrandInput = {
  businessStage?: InputMaybe<BusinessStage>;
  businessType?: InputMaybe<BusinessType>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EditBudgetInputType = {
  budgetType: BudgetType;
  minBudget?: InputMaybe<MoneyInput>;
};

export type EditCampaignMediaInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
};

export type EditCampaignProductInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type EditContentRequirementInputType = {
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasReview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  sendContentDate?: InputMaybe<Scalars['Date']['input']>;
};

export type EditCreatorRequirementsInputType = {
  /** Ids of the areas creators must live in, at any depth. They must belong to the brand's country. */
  areas?: InputMaybe<Array<Scalars['ID']['input']>>;
  genders?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  niches?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EditGiftCardInputType = {
  amount: MoneyInput;
  condition?: InputMaybe<Scalars['String']['input']>;
};

export type EditPriceProductInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type EditProductInputType = {
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: MoneyInput;
};

export type EditQuestionInputType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
};

export type EditReviewInputType = {
  aspectsToImprove?: InputMaybe<Array<AspectsToImproveEnum>>;
  calification: ReviewCalificationEnum;
  comments: Scalars['String']['input'];
  professionalism?: InputMaybe<ReviewCalificationEnum>;
  reviewId: Scalars['String']['input'];
  speed?: InputMaybe<ReviewCalificationEnum>;
  understanding?: InputMaybe<ReviewCalificationEnum>;
};

export type EditRightsOfUseInputType = {
  rightOfUse?: InputMaybe<Scalars['String']['input']>;
  rightOfUseMonths?: InputMaybe<Scalars['Int']['input']>;
  timeInProfile?: InputMaybe<Scalars['String']['input']>;
  timeInProfileMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type EditUserInput = {
  biography?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  creatorSegments?: InputMaybe<Array<CreatorSegmentEnum>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  genderId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `identifierInput`, which carries the type. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierInput?: InputMaybe<IdentificatorInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};

export type EditUserNicheInput = {
  kind: UserNicheKind;
  link?: InputMaybe<Scalars['String']['input']>;
  multipartUploadId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nicheId: Scalars['ID']['input'];
  postLink?: InputMaybe<Scalars['String']['input']>;
  socialNetworkUsername?: InputMaybe<Scalars['String']['input']>;
  userNicheId: Scalars['ID']['input'];
};

export type EditWorkOrderDetailDeliveryInput = {
  date: Scalars['Date']['input'];
  reviewDate?: InputMaybe<Scalars['Date']['input']>;
  rightOfUse: RightOfUse;
  rightOfUseMonths: Scalars['Int']['input'];
  script: Scalars['String']['input'];
  workOrderDetailId: Scalars['ID']['input'];
};

export type EtagsInput = {
  etag: Scalars['String']['input'];
  part: Scalars['Int']['input'];
};

/** An enumeration. */
export enum EventApplicationMode {
  InviteOnly = 'INVITE_ONLY',
  None = 'NONE',
  Open = 'OPEN'
}

/** An enumeration. */
export enum EventsEventApplicationModeChoices {
  /** Solo por invitación */
  InviteOnly = 'INVITE_ONLY',
  /** Sin postulación */
  None = 'NONE',
  /** Abierta a postulación */
  Open = 'OPEN'
}

/** An enumeration. */
export enum EventsEventApplicationStatusChoices {
  /** Aprobada */
  Approved = 'APPROVED',
  /** Rechazado */
  AutomaticRejection = 'AUTOMATIC_REJECTION',
  /** Rechazado */
  Rejected = 'REJECTED',
  /** Pendiente */
  Review = 'REVIEW'
}

/** An enumeration. */
export enum EventsEventInvitationStatusChoices {
  /** Aceptada */
  Accepted = 'ACCEPTED',
  /** Rechazada */
  Declined = 'DECLINED',
  /** Invitada */
  Invited = 'INVITED'
}

/** An enumeration. */
export enum EventsEventStatusChoices {
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum EventsEventTypeDefaultApplicationModeChoices {
  /** Solo por invitación */
  InviteOnly = 'INVITE_ONLY',
  /** Sin postulación */
  None = 'NONE',
  /** Abierta a postulación */
  Open = 'OPEN'
}

/** An enumeration. */
export enum EventsEventTypeNotificationChannelsChoices {
  /** Correo electrónico */
  Email = 'EMAIL',
  /** Notificación push */
  Push = 'PUSH',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP'
}

export type FinishWorkOrderInputType = {
  aspectsToImprove?: InputMaybe<Array<AspectsToImproveEnum>>;
  calification: ReviewCalificationEnum;
  comments: Scalars['String']['input'];
  professionalism?: InputMaybe<ReviewCalificationEnum>;
  speed?: InputMaybe<ReviewCalificationEnum>;
  understanding?: InputMaybe<ReviewCalificationEnum>;
  workOrderId: Scalars['String']['input'];
};

/** An enumeration. */
export enum FreeTrialStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type GenerateScriptInputType = {
  brandId: Scalars['ID']['input'];
  campaignTemplate: CampaignTemplateEnum;
  campaignType: CampaignTypeEnum;
  contentTemplate: ContentRequirementTemplate;
  duration: Scalars['Int']['input'];
  location: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
  videoSpecifications: Scalars['String']['input'];
};

export type GenerateScriptV2InputType = {
  brandId: Scalars['ID']['input'];
  campaignType: CampaignTypeEnum;
  contentTemplate: ContentRequirementTemplate;
  customerAwarenessLevel: CustomerAwarenessLevelEnum;
  duration: Scalars['Int']['input'];
  location: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
  sophisticationLevel: SophisticationLevelEnum;
  videoSpecifications: Scalars['String']['input'];
};

export enum GetLeaderboardOrderBy {
  Commission = 'COMMISSION',
  Count = 'COUNT'
}

/** An enumeration. */
export enum GroupEnum {
  Admin = 'ADMIN',
  Readonly = 'READONLY'
}

/**
 * What an ad platform left on the landing visit: the click id from the
 * ad's URL (`fbclid`, `ttclid`), the click cookie its pixel derived from it
 * (`_fbc`) and its browser id cookie (`_fbp`, `_ttp`).
 */
export type GuestAdClickInputType = {
  browserId?: InputMaybe<Scalars['String']['input']>;
  clickCookie?: InputMaybe<Scalars['String']['input']>;
  clickId?: InputMaybe<Scalars['String']['input']>;
  platform: AdPlatform;
};

/**
 * An identifier and the document type it is, as the app's identifier
 * input collects them. A client may omit the type (a country without types):
 * the field then detects it or skips validating it.
 */
export type IdentificatorInput = {
  type?: InputMaybe<IdentifierTypeEnum>;
  value: Scalars['String']['input'];
};

/**
 * A personal or tax document accepted in one country's context: the
 * prefix is that country, so `PE_PASSPORT` is a passport presented to a
 * Peruvian bank or SUNAT. Behavior per type lives in its handler
 * (`backend.resources.identifiers`).
 */
export enum IdentifierTypeEnum {
  ArCuit = 'AR_CUIT',
  ArDni = 'AR_DNI',
  ClRut = 'CL_RUT',
  CoCc = 'CO_CC',
  CoForeignerId = 'CO_FOREIGNER_ID',
  CoNit = 'CO_NIT',
  MxRfc = 'MX_RFC',
  PeDni = 'PE_DNI',
  PeForeignerCard = 'PE_FOREIGNER_CARD',
  PePassport = 'PE_PASSPORT',
  PeRuc = 'PE_RUC'
}

/** An enumeration. */
export enum IndustryEnum {
  AppsSaas = 'APPS_SAAS',
  Automotive = 'AUTOMOTIVE',
  Beauty = 'BEAUTY',
  Children = 'CHILDREN',
  ConsumerElectronics = 'CONSUMER_ELECTRONICS',
  Education = 'EDUCATION',
  Entertainment = 'ENTERTAINMENT',
  Fashion = 'FASHION',
  Financial = 'FINANCIAL',
  Fitness = 'FITNESS',
  Food = 'FOOD',
  Foodies = 'FOODIES',
  Foundations = 'FOUNDATIONS',
  Health = 'HEALTH',
  Home = 'HOME',
  Music = 'MUSIC',
  Other = 'OTHER',
  Perfumes = 'PERFUMES',
  Pets = 'PETS',
  Professional = 'PROFESSIONAL',
  Technology = 'TECHNOLOGY',
  Tourism = 'TOURISM'
}

/** An enumeration. */
export enum InvitationSourceEnum {
  AiRecommendation = 'AI_RECOMMENDATION',
  ManualSearch = 'MANUAL_SEARCH'
}

export type InviteWorkspaceUserInputType = {
  email: Scalars['String']['input'];
  group: GroupEnum;
};

export type LinkEcommerceDiscountCodeItemInput = {
  discountCode: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};

export type MoneyInput = {
  /** The numerical amount. */
  amount: Scalars['String']['input'];
  /** The ISO-421 3-letter currency code. */
  currency: Scalars['String']['input'];
};

/** An enumeration. */
export enum MontuAccountDeletionRequestStatusChoices {
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Completado */
  Completed = 'COMPLETED',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum MontuAfiliateProgramBenefitIconChoices {
  /** Insignia de porcentaje */
  BadgePercent = 'BADGE_PERCENT',
  /** Calendario */
  Calendar = 'CALENDAR',
  /** Cámara */
  Camera = 'CAMERA',
  /** Reloj */
  Clock = 'CLOCK',
  /** Signo de dólar */
  DollarSign = 'DOLLAR_SIGN',
  /** Regalo */
  Gift = 'GIFT',
  /** Paquete */
  Package = 'PACKAGE',
  /** Porcentaje */
  Percent = 'PERCENT',
  /** Polera */
  Shirt = 'SHIRT',
  /** Destellos */
  Sparkles = 'SPARKLES',
  /** Etiqueta */
  Tag = 'TAG',
  /** Ticket */
  Ticket = 'TICKET'
}

/** An enumeration. */
export enum MontuAfiliateProgramContentElaborationChoices {
  /** free */
  Free = 'FREE',
  /** specification */
  Sprecification = 'SPRECIFICATION'
}

/** An enumeration. */
export enum MontuAfiliateProgramContentUploadTimeframeChoices {
  /** En cualquier momento */
  Anytime = 'ANYTIME',
  /** La primera semana del mes */
  FirstWeek = 'FIRST_WEEK',
  /** La última semana del mes */
  LastWeek = 'LAST_WEEK',
  /** Una vez al mes */
  OnceAMonth = 'ONCE_A_MONTH',
  /** Una vez a la semana */
  OnceAWeek = 'ONCE_A_WEEK'
}

/** An enumeration. */
export enum MontuAfiliateProgramContentUploaderChoices {
  /** Influencer Post */
  Ambassador = 'AMBASSADOR',
  /** UGC */
  Brand = 'BRAND'
}

/** An enumeration. */
export enum MontuAfiliateProgramObjectiveChoices {
  /** Fidelizar clientes */
  BuildCustomerLoyalty = 'BUILD_CUSTOMER_LOYALTY',
  /** Cerrar ventas */
  CloseSales = 'CLOSE_SALES',
  /** Generar interés */
  GenerateInterest = 'GENERATE_INTEREST',
  /** Aumentar reconocimiento de la marca */
  IncreaseBrandAwareness = 'INCREASE_BRAND_AWARENESS'
}

/** An enumeration. */
export enum MontuAfiliateProgramPeriodicRewardMetricChoices {
  /** Comisión */
  Commission = 'COMMISSION',
  /** Cantidad */
  Count = 'COUNT',
  /** Ventas */
  Sales = 'SALES'
}

/** An enumeration. */
export enum MontuAfiliateProgramPeriodicRewardPeriodChoices {
  /** Todo el tiempo */
  AllTime = 'ALL_TIME',
  /** Mes */
  Month = 'MONTH',
  /** Año */
  Year = 'YEAR'
}

/** An enumeration. */
export enum MontuAfiliateProgramPostulationStatusChoices {
  /** Aceptada */
  Accepted = 'ACCEPTED',
  /** Pendiente */
  Pending = 'PENDING',
  /** Rechazado */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum MontuAfiliateProgramPriceProductDeliveryChoices {
  /** Mensual */
  Monthly = 'MONTHLY',
  /** Única vez */
  OnOff = 'ON_OFF',
  /** Semanal */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum MontuAfiliateProgramProductPaymentOptionChoices {
  /** general_awareness */
  GeneralAwareness = 'GENERAL_AWARENESS',
  /** specific_collection */
  SpecificCollection = 'SPECIFIC_COLLECTION',
  /** specific_product */
  SpecificProduct = 'SPECIFIC_PRODUCT'
}

/** An enumeration. */
export enum MontuAfiliateProgramStatusChoices {
  /** Cerrada */
  Closed = 'CLOSED',
  /** Abierta */
  Open = 'OPEN'
}

/** An enumeration. */
export enum MontuAfiliateProgramUserSaleMovementTypeChoices {
  /** Cierre */
  Closure = 'CLOSURE',
  /** Abierta */
  Opening = 'OPENING',
  /** Producto de canje */
  PriceProduct = 'PRICE_PRODUCT',
  /** Venta */
  Sale = 'SALE'
}

/** An enumeration. */
export enum MontuAfiliateProgramUserSalesPerPeriodStatusChoices {
  /** Abierta */
  Open = 'OPEN',
  /** Pagado */
  Payed = 'PAYED',
  /** Pendiente de pago */
  PendingPayment = 'PENDING_PAYMENT'
}

/** An enumeration. */
export enum MontuAfiliateProgramUserStatusChoices {
  /** Aceptada */
  Accepted = 'ACCEPTED',
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Pendiente */
  Pending = 'PENDING',
  /** Pre selección */
  PreSelection = 'PRE_SELECTION',
  /** Rechazado */
  Rejected = 'REJECTED',
  /** Terminado */
  Terminated = 'TERMINATED'
}

/** An enumeration. */
export enum MontuAfiliateProgramUserVariablePaymentTypeChoices {
  /** Ventas de producto específico */
  Product = 'PRODUCT',
  /** Ventas totales */
  TotalSales = 'TOTAL_SALES',
  /** Tráfico al sitio web */
  Traffic = 'TRAFFIC',
  /** Visitas a la página */
  Visits = 'VISITS'
}

/** An enumeration. */
export enum MontuAfiliateProgramVariablePaymentTypeChoices {
  /** Ventas de producto específico */
  Product = 'PRODUCT',
  /** Ventas totales */
  TotalSales = 'TOTAL_SALES',
  /** Tráfico al sitio web */
  Traffic = 'TRAFFIC',
  /** Visitas a la página */
  Visits = 'VISITS'
}

/** An enumeration. */
export enum MontuBankAccountAccountTypeChoices {
  /** Cuenta Corriente */
  Checking = 'CHECKING',
  /** Cuenta Vista */
  Debit = 'DEBIT',
  /** Cuenta de Ahorro */
  Savings = 'SAVINGS'
}

/** An enumeration. */
export enum MontuBrandBusinessStageChoices {
  /** Consolidación de marca */
  BrandConsolidation = 'BRAND_CONSOLIDATION',
  /** Expansión */
  Expansion = 'EXPANSION',
  /** Primeras ventas */
  FirstSales = 'FIRST_SALES',
  /** Escalabilidad */
  Scalability = 'SCALABILITY',
  /** Validación */
  Validation = 'VALIDATION'
}

/** An enumeration. */
export enum MontuBrandBusinessTypeChoices {
  /** Dropshipping */
  Dropshipping = 'DROPSHIPPING',
  /** Ecommerce */
  Ecommerce = 'ECOMMERCE',
  /** Tienda online */
  EcommerceStore = 'ECOMMERCE_STORE',
  /** Tienda de alimentos */
  FoodStore = 'FOOD_STORE',
  /** Servicio */
  Service = 'SERVICE',
  /** Tienda */
  Store = 'STORE'
}

/** An enumeration. */
export enum MontuBrandGraphicStatusChoices {
  /** Archivada */
  Archived = 'ARCHIVED',
  /** Publicado */
  Published = 'PUBLISHED'
}

/** An enumeration. */
export enum MontuBrandIndustryChoices {
  /** Alimentos y bebidas */
  Alimentos = 'ALIMENTOS',
  /** Apps y SaaS */
  AppsSaas = 'APPS_SAAS',
  /** Automotriz */
  Automotriz = 'AUTOMOTRIZ',
  /** Belleza y cuidado personal */
  Belleza = 'BELLEZA',
  /** Educación y cursos online */
  Educacion = 'EDUCACION',
  /** Electrónica de consumo */
  Electronica = 'ELECTRONICA',
  /** Entretenimiento y medios */
  Entretenimiento = 'ENTRETENIMIENTO',
  /** Servicios financieros */
  Financiero = 'FINANCIERO',
  /** Fitness y suplementos */
  Fitness = 'FITNESS',
  /** Foodies (restaurantes y comida en el local) */
  Foodies = 'FOODIES',
  /** Fundaciones */
  Fundaciones = 'FUNDACIONES',
  /** Inicio */
  Hogar = 'HOGAR',
  /** Infantil y maternidad */
  Infantil = 'INFANTIL',
  /** Mascotas */
  Mascotas = 'MASCOTAS',
  /** Moda y accesorios */
  Moda = 'MODA',
  /** Música */
  Musica = 'MUSICA',
  /** Otro */
  Otro = 'OTRO',
  /** Perfumes y fragancias */
  Perfumes = 'PERFUMES',
  /** Servicios profesionales (abogados, contadores, etc.) */
  Profesional = 'PROFESIONAL',
  /** Salud y bienestar */
  Salud = 'SALUD',
  /** Tecnología y electrónica */
  Tecnologia = 'TECNOLOGIA',
  /** Turismo */
  Turismo = 'TURISMO'
}

/** An enumeration. */
export enum MontuCampaignBudgetTypeChoices {
  /** Fixed */
  Fixed = 'FIXED',
  /** Off */
  Off = 'OFF',
  /** Quote */
  Quote = 'QUOTE'
}

/** An enumeration. */
export enum MontuCampaignCampaignTypeChoices {
  /** Afiliados */
  Affiliates = 'AFFILIATES',
  /** Meli */
  Meliclips = 'MELICLIPS',
  /** Orgánico */
  Organic = 'ORGANIC',
  /** UGC */
  Ugc = 'UGC',
  /** Viral */
  Viral = 'VIRAL'
}

/** An enumeration. */
export enum MontuCampaignDraftStatusChoices {
  /** Archivada */
  Archived = 'ARCHIVED',
  /** Cerrada */
  Closed = 'CLOSED',
  /** Abierta */
  Open = 'OPEN'
}

/** An enumeration. */
export enum MontuCampaignInvitationSourceChoices {
  /** Recomendación de IA */
  AiRecommendation = 'AI_RECOMMENDATION',
  /** Búsqueda manual */
  ManualSearch = 'MANUAL_SEARCH'
}

/** An enumeration. */
export enum MontuCampaignInvitationStatusChoices {
  /** Aceptada */
  Accepted = 'ACCEPTED',
  /** Rechazada */
  Declined = 'DECLINED',
  /** Pendiente */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum MontuCampaignObjectiveChoices {
  /** Fidelizar clientes */
  BuildCustomerLoyalty = 'BUILD_CUSTOMER_LOYALTY',
  /** Cerrar ventas */
  CloseSales = 'CLOSE_SALES',
  /** Generar interés */
  GenerateInterest = 'GENERATE_INTEREST',
  /** Aumentar reconocimiento de la marca */
  IncreaseBrandAwareness = 'INCREASE_BRAND_AWARENESS'
}

/** An enumeration. */
export enum MontuCampaignProductRelationCodeChoices {
  /** No aplica */
  DoesntApply = 'DOESNT_APPLY',
  /** Elige entre quedarte con el producto, o recibir un pago en efectivo */
  OptionalPrice = 'OPTIONAL_PRICE',
  /** El creador recibirá el producto como canje */
  Price = 'PRICE',
  /** El creador deberá devolver el producto después de crear el contenido */
  Shipment = 'SHIPMENT'
}

/** An enumeration. */
export enum MontuCampaignProductsCashPaymentCurrencyChoices {
  /** AR$ */
  Ars = 'ARS',
  /** R$ */
  Brl = 'BRL',
  /** $ */
  Clp = 'CLP',
  /** CO$ */
  Cop = 'COP',
  /** € */
  Eur = 'EUR',
  /** S/ */
  Pen = 'PEN',
  /** US$ */
  Usd = 'USD'
}

/** An enumeration. */
export enum MontuCampaignRightOfUseChoices {
  /** Para siempre */
  Forever = 'FOREVER',
  /** Limitada */
  Limited = 'LIMITED'
}

/** An enumeration. */
export enum MontuCampaignStatusChoices {
  /** Finalizada */
  Finished = 'FINISHED',
  /** Abierta */
  Open = 'OPEN'
}

/** An enumeration. */
export enum MontuCampaignTimeInProfileChoices {
  /** Para siempre */
  Forever = 'FOREVER',
  /** Limitada */
  Limited = 'LIMITED'
}

/** An enumeration. */
export enum MontuChatChatTypeChoices {
  /** Group */
  Group = 'GROUP',
  /** Individual */
  Individual = 'INDIVIDUAL'
}

/** An enumeration. */
export enum MontuChatMessageMessageTypeChoices {
  /** archive */
  Archive = 'ARCHIVE',
  /** audio */
  Audio = 'AUDIO',
  /** document */
  Document = 'DOCUMENT',
  /** image */
  Image = 'IMAGE',
  /** other */
  Other = 'OTHER',
  /** pdf */
  Pdf = 'PDF',
  /** text */
  Text = 'TEXT',
  /** video */
  Video = 'VIDEO'
}

/** An enumeration. */
export enum MontuCommentSentimentChoices {
  /** Negativo */
  Negative = 'NEGATIVE',
  /** Neutral */
  Neutral = 'NEUTRAL',
  /** Positivo */
  Positive = 'POSITIVE'
}

/** An enumeration. */
export enum MontuCommunityPostFeaturedIconChoices {
  /** Calendario */
  Calendar = 'CALENDAR',
  /** Regalo */
  Gift = 'GIFT',
  /** Bombillo */
  Lightbulb = 'LIGHTBULB',
  /** Megáfono */
  Megaphone = 'MEGAPHONE',
  /** Destellos */
  Sparkles = 'SPARKLES',
  /** Estrella */
  Star = 'STAR',
  /** Tendencia */
  TrendingUp = 'TRENDING_UP'
}

/** An enumeration. */
export enum MontuContentApprovalStatusChoices {
  /** Aprobada */
  Approved = 'APPROVED',
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Cancelado */
  CancelUploading = 'CANCEL_UPLOADING',
  /** Rechazado */
  Rejected = 'REJECTED',
  /** Pendiente */
  Review = 'REVIEW',
  /** Cargando */
  Uploading = 'UPLOADING'
}

/** An enumeration. */
export enum MontuContentRequirementTemplateChoices {
  /** Before after */
  BeforeAfter = 'BEFORE_AFTER',
  /** Carousel */
  Carousel = 'CAROUSEL',
  /** Demo */
  Demo = 'DEMO',
  /** Foodie */
  Foodie = 'FOODIE',
  /** Full viral */
  FullViral = 'FULL_VIRAL',
  /** Get ready with me */
  Grwm = 'GRWM',
  /** Microinfluencer */
  Microinfluencer = 'MICROINFLUENCER',
  /** None */
  None = 'NONE',
  /** Problem solution */
  ProblemSolution = 'PROBLEM_SOLUTION',
  /** Product launch */
  ProductLaunch = 'PRODUCT_LAUNCH',
  /** Review */
  Review = 'REVIEW',
  /** Social proofer */
  SocialProofer = 'SOCIAL_PROOFER',
  /** Special offer */
  SpecialOffer = 'SPECIAL_OFFER',
  /** Story */
  Story = 'STORY',
  /** Tutorial */
  Tutorial = 'TUTORIAL',
  /** Unboxing */
  Unboxing = 'UNBOXING',
  /** Unboxing + Demo */
  UnboxingDemo = 'UNBOXING_DEMO',
  /** Video */
  Video = 'VIDEO'
}

/** An enumeration. */
export enum MontuContentRequirementUploaderChoices {
  /** Influencer Post */
  Ambassador = 'AMBASSADOR',
  /** UGC */
  Brand = 'BRAND'
}

/** An enumeration. */
export enum MontuCreatorAppealStatusChoices {
  /** Aprobada */
  Approved = 'APPROVED',
  /** En revisión */
  InReview = 'IN_REVIEW',
  /** Pendiente */
  Pending = 'PENDING',
  /** Rechazada */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum MontuCreatorNotificationPreferenceCampaignTypesChoices {
  /** Afiliados */
  Affiliates = 'AFFILIATES',
  /** Meli */
  Meliclips = 'MELICLIPS',
  /** Orgánico */
  Organic = 'ORGANIC',
  /** UGC */
  Ugc = 'UGC',
  /** Viral */
  Viral = 'VIRAL'
}

/** An enumeration. */
export enum MontuCreatorRateAmountCurrencyChoices {
  /** AR$ */
  Ars = 'ARS',
  /** R$ */
  Brl = 'BRL',
  /** $ */
  Clp = 'CLP',
  /** CO$ */
  Cop = 'COP',
  /** € */
  Eur = 'EUR',
  /** S/ */
  Pen = 'PEN',
  /** US$ */
  Usd = 'USD'
}

/** An enumeration. */
export enum MontuCreatorReportReasonChoices {
  /** Entregó con atraso */
  LateDelivery = 'LATE_DELIVERY',
  /** No entregó contenido */
  NoContent = 'NO_CONTENT',
  /** Otro */
  Other = 'OTHER'
}

/** An enumeration. */
export enum MontuCreatorSegmentNameChoices {
  /** Influencer */
  Influencer = 'INFLUENCER',
  /** Modelo */
  Modelo = 'MODELO',
  /** Promotora */
  Promotora = 'PROMOTORA',
  /** Creador UGC */
  Ugc = 'UGC'
}

/** An enumeration. */
export enum MontuCreatorStrikeStatusChoices {
  /** Activa */
  Active = 'ACTIVE',
  /** Revertida */
  Reverted = 'REVERTED'
}

/** An enumeration. */
export enum MontuCuratedBrandBrandSizeChoices {
  /** Corporativa */
  Corporative = 'CORPORATIVE',
  /** Empresa */
  Enterprise = 'ENTERPRISE',
  /** Pyme */
  Pyme = 'PYME',
  /** Startup */
  Startup = 'STARTUP'
}

/** An enumeration. */
export enum MontuCuratedBrandCollaborationTypesChoices {
  /** Afiliado */
  Affiliate = 'AFFILIATE',
  /** Embajador */
  Ambassador = 'AMBASSADOR',
  /** Gifting */
  Gifting = 'GIFTING',
  /** Pagado */
  Paid = 'PAID'
}

/** An enumeration. */
export enum MontuCuratedBrandPriceRangeChoices {
  /** Económico */
  Budget = 'BUDGET',
  /** Lujo */
  Luxury = 'LUXURY',
  /** Medio */
  Mid = 'MID',
  /** Premium */
  Premium = 'PREMIUM'
}

/** An enumeration. */
export enum MontuCuratedBrandProductCategoriesChoices {
  /** Automotriz */
  Automotive = 'AUTOMOTIVE',
  /** Bebidas */
  Beverages = 'BEVERAGES',
  /** Infantil */
  Children = 'CHILDREN',
  /** Ropa */
  Clothing = 'CLOTHING',
  /** Educación */
  Education = 'EDUCATION',
  /** Entretenimiento */
  Entertainment = 'ENTERTAINMENT',
  /** Fitness */
  Fitness = 'FITNESS',
  /** Alimentos */
  Food = 'FOOD',
  /** Salud */
  Health = 'HEALTH',
  /** Decoración */
  HomeDecor = 'HOME_DECOR',
  /** Joyería */
  Jewelry = 'JEWELRY',
  /** Maquillaje */
  Makeup = 'MAKEUP',
  /** Otro */
  Other = 'OTHER',
  /** Mascotas */
  Pets = 'PETS',
  /** Skincare */
  Skincare = 'SKINCARE',
  /** Suplementos */
  Supplements = 'SUPPLEMENTS',
  /** Tecnología */
  Tech = 'TECH',
  /** Viajes */
  Travel = 'TRAVEL'
}

/** An enumeration. */
export enum MontuCuratedBrandTargetAudienceChoices {
  /** Todos */
  All = 'ALL',
  /** Boomer */
  Boomer = 'BOOMER',
  /** Gen X */
  GenX = 'GEN_X',
  /** Gen Z */
  GenZ = 'GEN_Z',
  /** Millennial */
  Millennial = 'MILLENNIAL'
}

/** An enumeration. */
export enum MontuCuratedBrandTargetGenderChoices {
  /** Femenino */
  Female = 'FEMALE',
  /** Masculino */
  Male = 'MALE',
  /** Unisex */
  Unisex = 'UNISEX'
}

/** An enumeration. */
export enum MontuDashboardEventKindChoices {
  /** Contenido entregado */
  ContentDelivered = 'CONTENT_DELIVERED',
  /** Postulationes */
  Postulations = 'POSTULATIONS',
  /** Publicación conectada */
  PostConnected = 'POST_CONNECTED',
  /** Orden de trabajo aceptada */
  WoAccepted = 'WO_ACCEPTED',
  /** Orden de trabajo rechazada */
  WoRejected = 'WO_REJECTED'
}

/** An enumeration. */
export enum MontuDraftMediaMediaTypeChoices {
  /** Archivo */
  Archive = 'ARCHIVE',
  /** Audio */
  Audio = 'AUDIO',
  /** Documento */
  Document = 'DOCUMENT',
  /** Imagen */
  Image = 'IMAGE',
  /** Otro */
  Other = 'OTHER',
  /** PDF */
  Pdf = 'PDF',
  /** Video */
  Video = 'VIDEO'
}

/** An enumeration. */
export enum MontuDraftMediaStatusChoices {
  /** Creado */
  Created = 'CREATED',
  /** Eliminado */
  Deleted = 'DELETED'
}

/** An enumeration. */
export enum MontuEcommerceOrderFinancialStatusChoices {
  /** AUTHORIZED */
  Authorized = 'AUTHORIZED',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** PAID */
  Paid = 'PAID',
  /** PARTIALLY_PAID */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** PARTIALLY_REFUNDED */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** PENDING */
  Pending = 'PENDING',
  /** REFUNDED */
  Refunded = 'REFUNDED',
  /** VOIDED */
  Voided = 'VOIDED'
}

/** An enumeration. */
export enum MontuGamificationAchievementDefinitionCodeChoices {
  /** address */
  Address = 'ADDRESS',
  /** brand_repeat */
  BrandRepeat = 'BRAND_REPEAT',
  /** contact_info */
  ContactInfo = 'CONTACT_INFO',
  /** course_pro */
  CoursePro = 'COURSE_PRO',
  /** course_ugc_basic */
  CourseUgcBasic = 'COURSE_UGC_BASIC',
  /** delivery_early */
  DeliveryEarly = 'DELIVERY_EARLY',
  /** delivery_late_48h */
  DeliveryLate_48H = 'DELIVERY_LATE_48H',
  /** delivery_on_time */
  DeliveryOnTime = 'DELIVERY_ON_TIME',
  /** ghosteo_chat */
  GhosteoChat = 'GHOSTEO_CHAT',
  /** ghosteo_collab */
  GhosteoCollab = 'GHOSTEO_COLLAB',
  /** ghosteo_odt */
  GhosteoOdt = 'GHOSTEO_ODT',
  /** manual_adjustment */
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  /** niches */
  Niches = 'NICHES',
  /** portfolio */
  Portfolio = 'PORTFOLIO',
  /** post_link_late */
  PostLinkLate = 'POST_LINK_LATE',
  /** post_link_on_time */
  PostLinkOnTime = 'POST_LINK_ON_TIME',
  /** profile_basics */
  ProfileBasics = 'PROFILE_BASICS',
  /** profile_bio */
  ProfileBio = 'PROFILE_BIO',
  /** referred */
  Referred = 'REFERRED',
  /** referred_collab */
  ReferredCollab = 'REFERRED_COLLAB',
  /** review_1_star */
  Review_1Star = 'REVIEW_1_STAR',
  /** review_2_stars */
  Review_2Stars = 'REVIEW_2_STARS',
  /** review_5_stars */
  Review_5Stars = 'REVIEW_5_STARS',
  /** social_disconnected */
  SocialDisconnected = 'SOCIAL_DISCONNECTED',
  /** social_network */
  SocialNetwork = 'SOCIAL_NETWORK',
  /** work_order_cancelled_by_creator_fault */
  WorkOrderCancelledByCreatorFault = 'WORK_ORDER_CANCELLED_BY_CREATOR_FAULT',
  /** work_order_completed */
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED'
}

/** An enumeration. */
export enum MontuGamificationEventCodeChoices {
  /** address */
  Address = 'ADDRESS',
  /** brand_repeat */
  BrandRepeat = 'BRAND_REPEAT',
  /** contact_info */
  ContactInfo = 'CONTACT_INFO',
  /** course_pro */
  CoursePro = 'COURSE_PRO',
  /** course_ugc_basic */
  CourseUgcBasic = 'COURSE_UGC_BASIC',
  /** delivery_early */
  DeliveryEarly = 'DELIVERY_EARLY',
  /** delivery_late_48h */
  DeliveryLate_48H = 'DELIVERY_LATE_48H',
  /** delivery_on_time */
  DeliveryOnTime = 'DELIVERY_ON_TIME',
  /** ghosteo_chat */
  GhosteoChat = 'GHOSTEO_CHAT',
  /** ghosteo_collab */
  GhosteoCollab = 'GHOSTEO_COLLAB',
  /** ghosteo_odt */
  GhosteoOdt = 'GHOSTEO_ODT',
  /** manual_adjustment */
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  /** niches */
  Niches = 'NICHES',
  /** portfolio */
  Portfolio = 'PORTFOLIO',
  /** post_link_late */
  PostLinkLate = 'POST_LINK_LATE',
  /** post_link_on_time */
  PostLinkOnTime = 'POST_LINK_ON_TIME',
  /** profile_basics */
  ProfileBasics = 'PROFILE_BASICS',
  /** profile_bio */
  ProfileBio = 'PROFILE_BIO',
  /** referred */
  Referred = 'REFERRED',
  /** referred_collab */
  ReferredCollab = 'REFERRED_COLLAB',
  /** review_1_star */
  Review_1Star = 'REVIEW_1_STAR',
  /** review_2_stars */
  Review_2Stars = 'REVIEW_2_STARS',
  /** review_5_stars */
  Review_5Stars = 'REVIEW_5_STARS',
  /** social_disconnected */
  SocialDisconnected = 'SOCIAL_DISCONNECTED',
  /** social_network */
  SocialNetwork = 'SOCIAL_NETWORK',
  /** work_order_cancelled_by_creator_fault */
  WorkOrderCancelledByCreatorFault = 'WORK_ORDER_CANCELLED_BY_CREATOR_FAULT',
  /** work_order_completed */
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED'
}

/** An enumeration. */
export enum MontuGamificationInterfaceLevelNameChoices {
  /** Bronce */
  Bronze = 'BRONZE',
  /** Oro */
  Gold = 'GOLD',
  /** Legendario */
  Legendary = 'LEGENDARY',
  /** Novato */
  Rookie = 'ROOKIE',
  /** Plata */
  Silver = 'SILVER'
}

/** An enumeration. */
export enum MontuInfluencerNicheNameChoices {
  /** Belleza */
  Beauty = 'BEAUTY',
  /** Alimentos, bebidas y licores */
  Beverages = 'BEVERAGES',
  /** Negocios y Emprendimiento */
  BusinessEntrepreneurship = 'BUSINESS_ENTREPRENEURSHIP',
  /** Cocina y Gastronomía */
  CookingGastronomy = 'COOKING_GASTRONOMY',
  /** Educación */
  Education = 'EDUCATION',
  /** Entretenimiento */
  Entertainment = 'ENTERTAINMENT',
  /** Moda */
  Fashion = 'FASHION',
  /** Fitness y Bienestar */
  FitnessWellness = 'FITNESS_WELLNESS',
  /** Foodies */
  Foodies = 'FOODIES',
  /** Gaming */
  Gaming = 'GAMING',
  /** Decoración de Interiores y DIY */
  InteriorDecorDiy = 'INTERIOR_DECOR_DIY',
  /** Maquillaje */
  Makeup = 'MAKEUP',
  /** Salud Mental y Crecimiento Personal */
  MentalHealthPersonalGrowth = 'MENTAL_HEALTH_PERSONAL_GROWTH',
  /** Fundaciones */
  NonProfits = 'NON_PROFITS',
  /** Mamás y Paternidad */
  Parenting = 'PARENTING',
  /** Mascotas */
  Pets = 'PETS',
  /** Tecnología */
  Technology = 'TECHNOLOGY',
  /** Viajes y Turismo */
  TravelTourism = 'TRAVEL_TOURISM'
}

/** An enumeration. */
export enum MontuInvoiceStatusChoices {
  /** Borrador */
  Draft = 'DRAFT',
  /** Fallida */
  Failed = 'FAILED',
  /** Emitida */
  Issued = 'ISSUED',
  /** Pendiente */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum MontuNotificationLevelChoices {
  /** erro */
  Error = 'ERROR',
  /** info */
  Info = 'INFO',
  /** success */
  Success = 'SUCCESS',
  /** warning */
  Warning = 'WARNING'
}

/** An enumeration. */
export enum MontuPostulationStatusChoices {
  /** Aprobada */
  Approved = 'APPROVED',
  /** Rechazado */
  AutomaticRejection = 'AUTOMATIC_REJECTION',
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Rechazado */
  Rejected = 'REJECTED',
  /** Pendiente */
  Review = 'REVIEW'
}

/** An enumeration. */
export enum MontuPreUploadRequirementRequirementChoices {
  /** Podrá ser usado para publicidad */
  Advertising = 'ADVERTISING',
  /** Debe ser subida a la página del creador */
  AmbassadorProfile = 'AMBASSADOR_PROFILE',
  /** El contenido será propiedad de la marca y podrá ser subido a sus Redes Sociales, Meta Ads, sitio web, etc */
  BrandOwned = 'BRAND_OWNED',
  /** Deberá subirse en forma colaborativa */
  Colaborative = 'COLABORATIVE',
  /** El creador deberá agregar a la marca como colaborador en la publicación. La marca podrá aceptar o no la colaboración dependiendo de la programación de su grilla, calidad del post, o algún otro factor. */
  ConditionalCollab = 'CONDITIONAL_COLLAB',
  /** El contenido deberá ser entregado a través de Montu. */
  DeliveredInMontu = 'DELIVERED_IN_MONTU',
  /** No puede subir publicaciones de otra marca dentro de 24 horas */
  Exclusivity = 'EXCLUSIVITY',
  /** El contenido NO SERÁ revisado por la marca antes de subirse */
  NoRevision = 'NO_REVISION',
  /** Debe permanecer al menos 24 horas en el perfil */
  Profile = 'PROFILE',
  /** Será revisado por la marca antes de subir */
  Revision = 'REVISION',
  /** El creador deberá enviar el contenido a la marca como respaldo */
  Support = 'SUPPORT',
  /** El influencer deberá etiquetar (no en colaboración) a la marca. */
  TagBrand = 'TAG_BRAND',
  /** El creador NO podrá subir el contenido a sus redes sociales, salvo autorización de la marca a través del chat. */
  UploadedOnlyWithAuthorization = 'UPLOADED_ONLY_WITH_AUTHORIZATION',
  /** La marca podrá solicitar ajustes y correcciones en la entrega del contenido. */
  VideoAdjustments = 'VIDEO_ADJUSTMENTS',
  /** Se despachará un producto para crear el contenido */
  WithProduct = 'WITH_PRODUCT'
}

/** An enumeration. */
export enum MontuReviewAspectsToImproveChoices {
  /** Comprensión del brief */
  BriefUnderstanding = 'BRIEF_UNDERSTANDING',
  /** Rapidez */
  Speed = 'SPEED',
  /** Storytelling */
  Storytelling = 'STORYTELLING',
  /** Versatilidad */
  Versatility = 'VERSATILITY',
  /** Calidad de video */
  VideoQuality = 'VIDEO_QUALITY'
}

/** An enumeration. */
export enum MontuScreenshotPostMetricReportStatusChoices {
  /** Failed */
  Failed = 'FAILED',
  /** Needs review */
  NeedsReview = 'NEEDS_REVIEW',
  /** Pending */
  Pending = 'PENDING',
  /** Processing */
  Processing = 'PROCESSING',
  /** Uploading */
  Uploading = 'UPLOADING',
  /** Verified */
  Verified = 'VERIFIED'
}

/** An enumeration. */
export enum MontuTaxKindChoices {
  /** Income retention */
  IncomeRetention = 'INCOME_RETENTION',
  /** Municipal retention */
  MunicipalRetention = 'MUNICIPAL_RETENTION',
  /** Payer income withholding */
  PayerIncomeWithholding = 'PAYER_INCOME_WITHHOLDING',
  /** Payer municipal withholding */
  PayerMunicipalWithholding = 'PAYER_MUNICIPAL_WITHHOLDING',
  /** Payer VAT withholding */
  PayerVatWithholding = 'PAYER_VAT_WITHHOLDING',
  /** VAT */
  Vat = 'VAT'
}

/** An enumeration. */
export enum MontuTaxProfileTaxRegimeChoices {
  /** Monotributo */
  ArMonotributo = 'AR_MONOTRIBUTO',
  /** Responsable inscripto */
  ArResponsableInscripto = 'AR_RESPONSABLE_INSCRIPTO',
  /** Factura electrónica */
  ClCompany = 'CL_COMPANY',
  /** Boleta de honorarios */
  ClNaturalPerson = 'CL_NATURAL_PERSON',
  /** Empresa */
  CoCompany = 'CO_COMPANY',
  /** Persona natural */
  CoNaturalPerson = 'CO_NATURAL_PERSON',
  /** No obligado a facturar */
  CoNonInvoicing = 'CO_NON_INVOICING',
  /** Régimen ordinario */
  CoOrdinary = 'CO_ORDINARY',
  /** Régimen Simple */
  CoSimple = 'CO_SIMPLE',
  /** Factura electrónica */
  PeCompany = 'PE_COMPANY',
  /** Recibo por honorarios */
  PeNaturalPerson = 'PE_NATURAL_PERSON'
}

/** An enumeration. */
export enum MontuWalletTaxRegimeChoices {
  /** Monotributo */
  ArMonotributo = 'AR_MONOTRIBUTO',
  /** Responsable inscripto */
  ArResponsableInscripto = 'AR_RESPONSABLE_INSCRIPTO',
  /** Factura electrónica */
  ClCompany = 'CL_COMPANY',
  /** Boleta de honorarios */
  ClNaturalPerson = 'CL_NATURAL_PERSON',
  /** Empresa */
  CoCompany = 'CO_COMPANY',
  /** Persona natural */
  CoNaturalPerson = 'CO_NATURAL_PERSON',
  /** No obligado a facturar */
  CoNonInvoicing = 'CO_NON_INVOICING',
  /** Régimen ordinario */
  CoOrdinary = 'CO_ORDINARY',
  /** Régimen Simple */
  CoSimple = 'CO_SIMPLE',
  /** Factura electrónica */
  PeCompany = 'PE_COMPANY',
  /** Recibo por honorarios */
  PeNaturalPerson = 'PE_NATURAL_PERSON'
}

/** An enumeration. */
export enum MontuWorkOrderCancelledReasonChoices {
  /** Creador reportado */
  CreatorReported = 'CREATOR_REPORTED',
  /** Sin acuerdo de precio */
  NoPriceAgreement = 'NO_PRICE_AGREEMENT',
  /** Sin respuesta a tiempo */
  NoResponseInTime = 'NO_RESPONSE_IN_TIME',
  /** Otro */
  Other = 'OTHER',
  /** Los horarios no eran compatibles */
  SchedulesNotCompatible = 'SCHEDULES_NOT_COMPATIBLE',
  /** Cancelada por suspensión */
  Suspension = 'SUSPENSION'
}

/** An enumeration. */
export enum MontuWorkOrderDeadlineChangeFieldChoices {
  /** Fecha de entrega */
  Date = 'DATE',
  /** Fecha de envío de contenido */
  SendContentDate = 'SEND_CONTENT_DATE'
}

/** An enumeration. */
export enum MontuWorkOrderDeadlineChangeSourceChoices {
  /** Extensión solicitada por la marca */
  BrandExtension = 'BRAND_EXTENSION',
  /** Ajuste automático por canje */
  CanjeAutoFloat = 'CANJE_AUTO_FLOAT'
}

/** An enumeration. */
export enum MontuWorkOrderDetailRightOfUseChoices {
  /** Para siempre */
  Forever = 'FOREVER',
  /** Limitada */
  Limited = 'LIMITED'
}

/** An enumeration. */
export enum MontuWorkOrderDetailUploaderChoices {
  /** Influencer Post */
  Ambassador = 'AMBASSADOR',
  /** UGC */
  Brand = 'BRAND'
}

/** An enumeration. */
export enum MontuWorkOrderPaymentMethodChoices {
  /** credit */
  Credit = 'CREDIT',
  /** debit */
  Debit = 'DEBIT',
  /** free */
  Free = 'FREE',
  /** wallet */
  Wallet = 'WALLET'
}

/** An enumeration. */
export enum MontuWorkOrderStatusChoices {
  /** Aceptada */
  Accepted = 'ACCEPTED',
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Rechazada */
  Declined = 'DECLINED',
  /** Finalizada */
  Finished = 'FINISHED',
  /** Pendiente */
  Pending = 'PENDING',
  /** Pendiente de pago */
  PendingPayment = 'PENDING_PAYMENT'
}

/** An enumeration. */
export enum MontuWorkOrderTaxRegimeChoices {
  /** Monotributo */
  ArMonotributo = 'AR_MONOTRIBUTO',
  /** Responsable inscripto */
  ArResponsableInscripto = 'AR_RESPONSABLE_INSCRIPTO',
  /** Factura electrónica */
  ClCompany = 'CL_COMPANY',
  /** Boleta de honorarios */
  ClNaturalPerson = 'CL_NATURAL_PERSON',
  /** Empresa */
  CoCompany = 'CO_COMPANY',
  /** Persona natural */
  CoNaturalPerson = 'CO_NATURAL_PERSON',
  /** No obligado a facturar */
  CoNonInvoicing = 'CO_NON_INVOICING',
  /** Régimen ordinario */
  CoOrdinary = 'CO_ORDINARY',
  /** Régimen Simple */
  CoSimple = 'CO_SIMPLE',
  /** Factura electrónica */
  PeCompany = 'PE_COMPANY',
  /** Recibo por honorarios */
  PeNaturalPerson = 'PE_NATURAL_PERSON'
}

/** An enumeration. */
export enum MontuWorkOrderTerminalReasonChoices {
  /** Cancelada por el creador: producto nunca enviado */
  CancelByCreatorNoShipping = 'CANCEL_BY_CREATOR_NO_SHIPPING',
  /** Cancelada: el creador no aceptó a tiempo */
  CancelNoAcceptance = 'CANCEL_NO_ACCEPTANCE',
  /** Cancelada: no se entregó el contenido */
  CancelNoDelivery = 'CANCEL_NO_DELIVERY',
  /** Cancelada: la marca no pagó */
  CancelNoPayment = 'CANCEL_NO_PAYMENT',
  /** Cancelada: no se conectó la publicación */
  CancelNoPost = 'CANCEL_NO_POST',
  /** Cancelada: la marca no envió los productos */
  CancelNoShipping = 'CANCEL_NO_SHIPPING',
  /** Finalizada automáticamente */
  FinalizeAuto = 'FINALIZE_AUTO',
  /** Finalizada por la marca */
  FinalizeManual = 'FINALIZE_MANUAL'
}

/** An enumeration. */
export enum MontuWorkspaceCreatorStatusChoices {
  /** Active */
  Active = 'ACTIVE',
  /** Revoked */
  Revoked = 'REVOKED'
}

/** An enumeration. */
export enum MontuWorkspaceInvitationGroupChoices {
  /** Admin */
  Admin = 'ADMIN',
  /** Read only */
  Readonly = 'READONLY'
}

/** An enumeration. */
export enum MontuWorkspaceInvitationStatusChoices {
  /** Aceptada */
  Accepted = 'ACCEPTED',
  /** Pendiente */
  Pending = 'PENDING',
  /** Revocado */
  Revoked = 'REVOKED'
}

/** An enumeration. */
export enum MontuWorkspaceOnboardingCallStatusChoices {
  /** Agendada */
  Booked = 'BOOKED',
  /** No ofrecida */
  None = 'NONE',
  /** Omitida */
  Skipped = 'SKIPPED'
}

/** An enumeration. */
export enum MontuWorkspaceSourceChoices {
  /** Click Funnels */
  ClickFunnels = 'CLICK_FUNNELS',
  /** Google */
  Google = 'GOOGLE',
  /** Guest start */
  GuestStart = 'GUEST_START',
  /** Landing page */
  LandingPage = 'LANDING_PAGE',
  /** Otro */
  Other = 'OTHER',
  /** Recomendación */
  Recommendation = 'RECOMMENDATION',
  /** Redes sociales */
  SocialNetworks = 'SOCIAL_NETWORKS'
}

/**
 * Discriminator for multipart uploads.
 *
 * Each `purpose` is bound to:
 *   * a target storage backend (`private` or `public`)
 *   * a key prefix (the `upload_to` directory)
 *   * the entity type that ultimately consumes the file.
 *
 */
export enum MultipartUploadPurpose {
  BrandGraphicImage = 'BRAND_GRAPHIC_IMAGE',
  CommunityPostImage = 'COMMUNITY_POST_IMAGE',
  CommunityPostVideo = 'COMMUNITY_POST_VIDEO',
  CommunityPostVideoThumbnail = 'COMMUNITY_POST_VIDEO_THUMBNAIL',
  LessonQuizSubmission = 'LESSON_QUIZ_SUBMISSION',
  ScreenshotPostMetric = 'SCREENSHOT_POST_METRIC',
  UserNicheVideo = 'USER_NICHE_VIDEO',
  UserPortfolioVideo = 'USER_PORTFOLIO_VIDEO',
  WorkOrderContentApproval = 'WORK_ORDER_CONTENT_APPROVAL'
}

export enum MyCampaignRunningStatus {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  InPlace = 'IN_PLACE',
  Pending = 'PENDING',
  Postulation = 'POSTULATION'
}

/** An enumeration. */
export enum NotificationEventKey {
  AccountBanned = 'ACCOUNT_BANNED',
  AccountSuspended = 'ACCOUNT_SUSPENDED',
  AffiliateSalesGenerated = 'AFFILIATE_SALES_GENERATED',
  AutoReportConfirmed = 'AUTO_REPORT_CONFIRMED',
  BrandSegmentBroadcast = 'BRAND_SEGMENT_BROADCAST',
  CampaignInvitation = 'CAMPAIGN_INVITATION',
  CampaignNoHireReminder = 'CAMPAIGN_NO_HIRE_REMINDER',
  CampaignPublished = 'CAMPAIGN_PUBLISHED',
  CanjeCancelOptionUnlocked = 'CANJE_CANCEL_OPTION_UNLOCKED',
  CanjeMarkShipment = 'CANJE_MARK_SHIPMENT',
  CanjeShipped = 'CANJE_SHIPPED',
  ChatMessageFromBrand = 'CHAT_MESSAGE_FROM_BRAND',
  ChatMessageFromCreator = 'CHAT_MESSAGE_FROM_CREATOR',
  ChatUnreadBrand = 'CHAT_UNREAD_BRAND',
  ChatUnreadCreator = 'CHAT_UNREAD_CREATOR',
  CommunityPostPublished = 'COMMUNITY_POST_PUBLISHED',
  ContentApproved = 'CONTENT_APPROVED',
  ContentAutoApproved = 'CONTENT_AUTO_APPROVED',
  ContentReviewExpiring = 'CONTENT_REVIEW_EXPIRING',
  ContentSubmitted = 'CONTENT_SUBMITTED',
  CreatorAppealApproved = 'CREATOR_APPEAL_APPROVED',
  CreatorAppealRejected = 'CREATOR_APPEAL_REJECTED',
  CreatorReportProcessed = 'CREATOR_REPORT_PROCESSED',
  DeadlineAutocancelWarning = 'DEADLINE_AUTOCANCEL_WARNING',
  DeadlineAutoExtended = 'DEADLINE_AUTO_EXTENDED',
  DeadlineFinalWarning = 'DEADLINE_FINAL_WARNING',
  DeadlineGraceReminder = 'DEADLINE_GRACE_REMINDER',
  DeadlineImminent = 'DEADLINE_IMMINENT',
  DeadlineMissed = 'DEADLINE_MISSED',
  DeadlineUpcoming = 'DEADLINE_UPCOMING',
  EventApplicationApproved = 'EVENT_APPLICATION_APPROVED',
  EventApplicationRejected = 'EVENT_APPLICATION_REJECTED',
  EventCancelled = 'EVENT_CANCELLED',
  EventPublished = 'EVENT_PUBLISHED',
  GamificationAlmostThere = 'GAMIFICATION_ALMOST_THERE',
  GamificationBigGain = 'GAMIFICATION_BIG_GAIN',
  GamificationInactiveNudge = 'GAMIFICATION_INACTIVE_NUDGE',
  GamificationLevelUp = 'GAMIFICATION_LEVEL_UP',
  PaymentReleased = 'PAYMENT_RELEASED',
  PostulationApplicationsMilestone = 'POSTULATION_APPLICATIONS_MILESTONE',
  PostulationApproved = 'POSTULATION_APPROVED',
  PostulationAutoRejected = 'POSTULATION_AUTO_REJECTED',
  PostulationExpiring = 'POSTULATION_EXPIRING',
  PostulationRejected = 'POSTULATION_REJECTED',
  PostConnected = 'POST_CONNECTED',
  PublicationAutocancelWarning = 'PUBLICATION_AUTOCANCEL_WARNING',
  PublicationMissed = 'PUBLICATION_MISSED',
  PublicationScreenshotFailed = 'PUBLICATION_SCREENSHOT_FAILED',
  PublicationScreenshotNeedsReview = 'PUBLICATION_SCREENSHOT_NEEDS_REVIEW',
  PublicationScreenshotVerified = 'PUBLICATION_SCREENSHOT_VERIFIED',
  PublicationUpcoming = 'PUBLICATION_UPCOMING',
  RevisionIdle = 'REVISION_IDLE',
  RevisionRequested = 'REVISION_REQUESTED',
  WalletDeposited = 'WALLET_DEPOSITED',
  WithdrawalFailed = 'WITHDRAWAL_FAILED',
  WorkOrderAcceptanceExpiring = 'WORK_ORDER_ACCEPTANCE_EXPIRING',
  WorkOrderAccepted = 'WORK_ORDER_ACCEPTED',
  WorkOrderCancelledNoAcceptance = 'WORK_ORDER_CANCELLED_NO_ACCEPTANCE',
  WorkOrderCancelledNoDelivery = 'WORK_ORDER_CANCELLED_NO_DELIVERY',
  WorkOrderCancelledNoPayment = 'WORK_ORDER_CANCELLED_NO_PAYMENT',
  WorkOrderCancelledNoPost = 'WORK_ORDER_CANCELLED_NO_POST',
  WorkOrderCancelledNoShipping = 'WORK_ORDER_CANCELLED_NO_SHIPPING',
  WorkOrderClosureReminder = 'WORK_ORDER_CLOSURE_REMINDER',
  WorkOrderDeclined = 'WORK_ORDER_DECLINED',
  WorkOrderFinalized = 'WORK_ORDER_FINALIZED',
  WorkOrderOverdue = 'WORK_ORDER_OVERDUE',
  WorkOrderPaymentPending = 'WORK_ORDER_PAYMENT_PENDING',
  WorkOrderSent = 'WORK_ORDER_SENT'
}

/** An enumeration. */
export enum OnboardingCallStatusEnum {
  Booked = 'BOOKED',
  None = 'NONE',
  Skipped = 'SKIPPED'
}

/** A single (id, order) pair for the reorder mutations. */
export type OrderInputType = {
  id: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
};

/**
 * Whose perspective a `PaymentBreakdown` is rendered for -- the brand
 * paying (`PAYER`, the default) or the creator/ambassador receiving the
 * money (`PAYEE`). `PAYEE` drops the fee/tax lines that don't apply to
 * them and relabels the net/retention lines from their point of view.
 */
export enum PaymentAudienceEnum {
  Payee = 'PAYEE',
  Payer = 'PAYER'
}

/** An enumeration. */
export enum PaymentLineKind {
  CreatorNet = 'CREATOR_NET',
  InvoiceTotal = 'INVOICE_TOTAL',
  PayerWithholding = 'PAYER_WITHHOLDING',
  ProviderFee = 'PROVIDER_FEE',
  Retention = 'RETENTION',
  ServiceFee = 'SERVICE_FEE',
  Subtotal = 'SUBTOTAL',
  Total = 'TOTAL',
  Vat = 'VAT'
}

/** An enumeration. */
export enum PaymentLineRole {
  Line = 'LINE',
  Subtotal = 'SUBTOTAL',
  Total = 'TOTAL'
}

/**
 * How `subscriptions.paymentMethodUpdateUrl` expects the returned `url`
 * to be used: a provider-hosted card-update page, or a fresh checkout the
 * payer resubscribes through (providers with no hosted card-update page).
 */
export enum PaymentMethodUpdateModeEnum {
  HostedCardUpdate = 'HOSTED_CARD_UPDATE',
  Resubscribe = 'RESUBSCRIBE'
}

/**
 * One creator's net amount for `TaxQuery.creator_payment_breakdown`.
 * `user_id` is optional -- when given, the resolver looks up that
 * creator's own tax profile to decide whether the item withholds; when
 * omitted, the item defaults to withholding.
 */
export type PaymentPreviewItemInput = {
  amount: MoneyInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum Payments {
  Cash = 'CASH',
  GiftCard = 'GIFT_CARD',
  PriceProduct = 'PRICE_PRODUCT'
}

/** An enumeration. */
export enum PersonKindEnum {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

/** An enumeration. */
export enum PlanEnum {
  Emprende = 'EMPRENDE',
  Enterprise = 'ENTERPRISE',
  Lite = 'LITE',
  Plus = 'PLUS',
  Starter = 'STARTER',
  Test = 'TEST',
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum PlanOrganicCampaignTarget {
  Interactions = 'INTERACTIONS',
  Reach = 'REACH',
  Views = 'VIEWS'
}

/** An enumeration. */
export enum PlatformCodeEnum {
  Apify = 'APIFY',
  Apple = 'APPLE',
  Bsale = 'BSALE',
  Clickfunnels = 'CLICKFUNNELS',
  Eclectic = 'ECLECTIC',
  Gemini = 'GEMINI',
  Google = 'GOOGLE',
  Instagram = 'INSTAGRAM',
  Magento = 'MAGENTO',
  MercadoLibre = 'MERCADO_LIBRE',
  Meta = 'META',
  MetaConversions = 'META_CONVERSIONS',
  Microsoft = 'MICROSOFT',
  Monday = 'MONDAY',
  Openai = 'OPENAI',
  RetailPro = 'RETAIL_PRO',
  SalesFeed = 'SALES_FEED',
  Services = 'SERVICES',
  Shopify = 'SHOPIFY',
  Sii = 'SII',
  TikTok = 'TIK_TOK',
  TikTokConversions = 'TIK_TOK_CONVERSIONS',
  TuPana = 'TU_PANA',
  Vimeo = 'VIMEO',
  Woocommerce = 'WOOCOMMERCE'
}

export type PostulateInput = {
  amountOffered?: InputMaybe<MoneyInput>;
  answers: Array<PostulationAnswerInput>;
  campaignId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  uploads?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  userAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type PostulationAnswerInput = {
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type PreSelectInput = {
  afiliateProgramId: Scalars['String']['input'];
  users: Array<Scalars['String']['input']>;
};

/** An enumeration. */
export enum PreUploadRequirementEnum {
  AmbassadorPost = 'AMBASSADOR_POST',
  BrandOwned = 'BRAND_OWNED',
  Colaborative = 'COLABORATIVE',
  ConditionalCollab = 'CONDITIONAL_COLLAB',
  DeliveredInMontu = 'DELIVERED_IN_MONTU',
  Exclusivity = 'EXCLUSIVITY',
  InProfile = 'IN_PROFILE',
  NoRevision = 'NO_REVISION',
  Revision = 'REVISION',
  Support = 'SUPPORT',
  TagBrand = 'TAG_BRAND',
  UploadedOnlyWithAuthorization = 'UPLOADED_ONLY_WITH_AUTHORIZATION',
  UseAdvertising = 'USE_ADVERTISING',
  VideoAdjustments = 'VIDEO_ADJUSTMENTS',
  WithProduct = 'WITH_PRODUCT'
}

export type PriceProductInput = {
  delivery: DeliveryFrecuencyOptions;
  productId: Scalars['String']['input'];
};

/** An enumeration. */
export enum PricingNameEnum {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type ProductInputType = {
  brandId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: MoneyInput;
};

/** An enumeration. */
export enum ProductPaymentOption {
  GeneralAwareness = 'GENERAL_AWARENESS',
  SpecificCollection = 'SPECIFIC_COLLECTION',
  SpecificProduct = 'SPECIFIC_PRODUCT'
}

export type ProgramContentInput = {
  description: Scalars['String']['input'];
  postType: Scalars['String']['input'];
  references: Array<Scalars['String']['input']>;
  uploadDate: UploadTimeframeOptions;
  uploader: ContentRequirementUploaderEnum;
};

/** An enumeration. */
export enum QuotaCode {
  AffiliateAmbassador = 'AFFILIATE_AMBASSADOR',
  Analytics = 'ANALYTICS',
  ApplicationsMilestone = 'APPLICATIONS_MILESTONE',
  Brands = 'BRANDS',
  CampaignDurationHours = 'CAMPAIGN_DURATION_HOURS',
  CampaignScoring = 'CAMPAIGN_SCORING',
  Chats = 'CHATS',
  ContactData = 'CONTACT_DATA',
  CreateCampaign = 'CREATE_CAMPAIGN',
  EcommerceIntegration = 'ECOMMERCE_INTEGRATION',
  NoHireReminderHours = 'NO_HIRE_REMINDER_HOURS',
  PayByPurchaseOrder = 'PAY_BY_PURCHASE_ORDER',
  PostulationCanva = 'POSTULATION_CANVA',
  PostulationInsights = 'POSTULATION_INSIGHTS',
  PostulationReviews = 'POSTULATION_REVIEWS',
  PrivateCreators = 'PRIVATE_CREATORS',
  RecommendedCreators = 'RECOMMENDED_CREATORS',
  ScriptGenerator = 'SCRIPT_GENERATOR',
  SearchUsers = 'SEARCH_USERS',
  TrialExtensionDays = 'TRIAL_EXTENSION_DAYS',
  TrialHours = 'TRIAL_HOURS',
  Users = 'USERS',
  VisiblePostulations = 'VISIBLE_POSTULATIONS',
  WalletPayment = 'WALLET_PAYMENT',
  WorkOrders = 'WORK_ORDERS',
  WorkOrderAttempts = 'WORK_ORDER_ATTEMPTS'
}

export type ReactivateAfiliateProgramUserInputType = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ReferenceInputType = {
  link: Scalars['String']['input'];
};

/** An enumeration. */
export enum ReviewCalificationEnum {
  Average = 'AVERAGE',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Poor = 'POOR',
  Terrible = 'TERRIBLE'
}

/** An enumeration. */
export enum RightOfUse {
  Forever = 'FOREVER',
  Limited = 'LIMITED'
}

/** An enumeration. */
export enum SalesTimelineGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum SanctionStatusEnum {
  Banned = 'BANNED',
  None = 'NONE',
  Suspended = 'SUSPENDED'
}

export type SelectAffiliateProgramUserInput = {
  afiliateProgramUserId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type SendToSegmentInput = {
  afiliateProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  afiliateUserStatuses?: InputMaybe<Array<AfiliateUserStatus>>;
  brandId: Scalars['ID']['input'];
  joinedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** An enumeration. */
export enum ShoeSizeEnum {
  Us_4 = 'US_4',
  Us_4_5 = 'US_4_5',
  Us_5 = 'US_5',
  Us_5_5 = 'US_5_5',
  Us_6 = 'US_6',
  Us_6_5 = 'US_6_5',
  Us_7 = 'US_7',
  Us_7_5 = 'US_7_5',
  Us_8 = 'US_8',
  Us_8_5 = 'US_8_5',
  Us_9 = 'US_9',
  Us_9_5 = 'US_9_5',
  Us_10 = 'US_10',
  Us_10_5 = 'US_10_5',
  Us_11 = 'US_11',
  Us_11_5 = 'US_11_5',
  Us_12 = 'US_12',
  Us_12_5 = 'US_12_5',
  Us_13 = 'US_13',
  Us_14 = 'US_14',
  Us_15 = 'US_15'
}

export type SocialUserPlatformUsernameInput = {
  platformCode: PlatformCodeEnum;
  username: Scalars['String']['input'];
};

/** An enumeration. */
export enum SophisticationLevelEnum {
  FifthStage = 'FIFTH_STAGE',
  FirstToMarket = 'FIRST_TO_MARKET',
  FourthStage = 'FOURTH_STAGE',
  SecondToMarket = 'SECOND_TO_MARKET',
  ThirdStage = 'THIRD_STAGE'
}

export type StartShopifyInstallInput = {
  brandId: Scalars['ID']['input'];
  shopifyParams: Scalars['String']['input'];
};

export type StartWooCommerceInstallInput = {
  brandId: Scalars['ID']['input'];
  host: Scalars['String']['input'];
};

/** An enumeration. */
export enum SubscriptionAbilities {
  AddAffiliateAmbassador = 'ADD_AFFILIATE_AMBASSADOR',
  AddBrand = 'ADD_BRAND',
  AddUser = 'ADD_USER',
  Analytics = 'ANALYTICS',
  CampaignScoring = 'CAMPAIGN_SCORING',
  Chats = 'CHATS',
  ContactData = 'CONTACT_DATA',
  CreateCampaign = 'CREATE_CAMPAIGN',
  EcommerceIntegration = 'ECOMMERCE_INTEGRATION',
  PayByPurchaseOrder = 'PAY_BY_PURCHASE_ORDER',
  PostulationCanva = 'POSTULATION_CANVA',
  PostulationInsights = 'POSTULATION_INSIGHTS',
  PostulationReviews = 'POSTULATION_REVIEWS',
  PrivateCreators = 'PRIVATE_CREATORS',
  RecommendedCreators = 'RECOMMENDED_CREATORS',
  ScriptGenerator = 'SCRIPT_GENERATOR',
  SearchUsers = 'SEARCH_USERS',
  SendWorkOrder = 'SEND_WORK_ORDER',
  WalletPayment = 'WALLET_PAYMENT'
}

/** An enumeration. */
export enum SubscriptionIntentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum SubscriptionsPaymentRecurringFrequencyTypeChoices {
  /** days */
  Days = 'DAYS',
  /** months */
  Months = 'MONTHS'
}

/** An enumeration. */
export enum SubscriptionsPaymentRecurringSemaphoreChoices {
  /** Blank */
  Blank = 'BLANK',
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED',
  /** Yellow */
  Yellow = 'YELLOW'
}

/** An enumeration. */
export enum SubscriptionsPaymentRecurringStatusChoices {
  /** active */
  Active = 'ACTIVE',
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** defaulted */
  Defaulted = 'DEFAULTED',
  /** finished */
  Finished = 'FINISHED',
  /** paused */
  Paused = 'PAUSED',
  /** pending */
  Pending = 'PENDING',
  /** retrying */
  Retrying = 'RETRYING'
}

/** An enumeration. */
export enum SubscriptionsPlanCodeChoices {
  /** EMPRENDE */
  Emprende = 'EMPRENDE',
  /** ENTERPRISE */
  Enterprise = 'ENTERPRISE',
  /** LITE */
  Lite = 'LITE',
  /** PLUS */
  Plus = 'PLUS',
  /** STARTER */
  Starter = 'STARTER',
  /** TEST */
  Test = 'TEST',
  /** TRIAL */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum SubscriptionsPricingNameChoices {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

/** An enumeration. */
export enum SubscriptionsQuotaCodeChoices {
  /** affiliate_ambassador */
  AffiliateAmbassador = 'AFFILIATE_AMBASSADOR',
  /** analytics */
  Analytics = 'ANALYTICS',
  /** applications_milestone */
  ApplicationsMilestone = 'APPLICATIONS_MILESTONE',
  /** brands */
  Brands = 'BRANDS',
  /** campaign_duration_hours */
  CampaignDurationHours = 'CAMPAIGN_DURATION_HOURS',
  /** campaign_scoring */
  CampaignScoring = 'CAMPAIGN_SCORING',
  /** chats */
  Chats = 'CHATS',
  /** contact_data */
  ContactData = 'CONTACT_DATA',
  /** create_campaign */
  CreateCampaign = 'CREATE_CAMPAIGN',
  /** ecommerce_integration */
  EcommerceIntegration = 'ECOMMERCE_INTEGRATION',
  /** no_hire_reminder_hours */
  NoHireReminderHours = 'NO_HIRE_REMINDER_HOURS',
  /** pay_purchase_order */
  PayPurchaseOrder = 'PAY_PURCHASE_ORDER',
  /** postulation_canva */
  PostulationCanva = 'POSTULATION_CANVA',
  /** postulation_insights */
  PostulationInsights = 'POSTULATION_INSIGHTS',
  /** postulation_review */
  PostulationReview = 'POSTULATION_REVIEW',
  /** private_creators */
  PrivateCreators = 'PRIVATE_CREATORS',
  /** recommended_creators */
  RecommendedCreators = 'RECOMMENDED_CREATORS',
  /** script_generator */
  ScriptGenerator = 'SCRIPT_GENERATOR',
  /** search_users */
  SearchUsers = 'SEARCH_USERS',
  /** trial_extension_days */
  TrialExtensionDays = 'TRIAL_EXTENSION_DAYS',
  /** trial_hours */
  TrialHours = 'TRIAL_HOURS',
  /** users */
  Users = 'USERS',
  /** visible_postulations */
  VisiblePostulations = 'VISIBLE_POSTULATIONS',
  /** wallet_payment */
  WalletPayment = 'WALLET_PAYMENT',
  /** work_orders */
  WorkOrders = 'WORK_ORDERS',
  /** work_order_attempts */
  WorkOrderAttempts = 'WORK_ORDER_ATTEMPTS'
}

/**
 * A structured address on the profile country's area tree. The country
 * is the profile's own, never chosen by the client.
 */
export type TaxProfileAddressInputType = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  areaId: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  route: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Where a tax profile form field is stored: each value is the
 * `TaxProfile` attribute it fills, so completeness can read it back.
 */
export enum TaxProfileFieldKeyEnum {
  Address = 'ADDRESS',
  AddressLine = 'ADDRESS_LINE',
  BusinessActivity = 'BUSINESS_ACTIVITY',
  Email = 'EMAIL',
  IsLargeTaxpayer = 'IS_LARGE_TAXPAYER',
  IsMunicipalWithholdingAgent = 'IS_MUNICIPAL_WITHHOLDING_AGENT',
  LegalName = 'LEGAL_NAME',
  TaxId = 'TAX_ID',
  TaxRegime = 'TAX_REGIME'
}

/**
 * How a tax profile form field is rendered and validated. The apps have
 * one component per kind and never branch on the country.
 */
export enum TaxProfileFieldKindEnum {
  Address = 'ADDRESS',
  Boolean = 'BOOLEAN',
  Email = 'EMAIL',
  Identifier = 'IDENTIFIER',
  Regime = 'REGIME',
  Text = 'TEXT'
}

export type TaxProfileInputType = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressInput?: InputMaybe<TaxProfileAddressInputType>;
  businessActivity?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isLargeTaxpayer?: InputMaybe<Scalars['Boolean']['input']>;
  isMunicipalWithholdingAgent?: InputMaybe<Scalars['Boolean']['input']>;
  legalName: Scalars['String']['input'];
  /** @deprecated Use `taxIdInput`, which carries the type. */
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdInput?: InputMaybe<IdentificatorInput>;
  taxRegime?: InputMaybe<TaxRegimeEnum>;
};

/** An enumeration. */
export enum TaxProfileOwnerKindEnum {
  Brand = 'BRAND',
  Creator = 'CREATOR',
  Workspace = 'WORKSPACE'
}

/**
 * The owner's fiscal status: how a creator gets paid, or what document a
 * payer (brand/workspace) receives. Members name the person kind, not the
 * document -- the document (boleta/factura/recibo) is derived per-country
 * copy on `TaxRegimeOption`, not part of the code.
 */
export enum TaxRegimeEnum {
  ArMonotributo = 'AR_MONOTRIBUTO',
  ArResponsableInscripto = 'AR_RESPONSABLE_INSCRIPTO',
  ClCompany = 'CL_COMPANY',
  ClNaturalPerson = 'CL_NATURAL_PERSON',
  CoCompany = 'CO_COMPANY',
  CoNaturalPerson = 'CO_NATURAL_PERSON',
  CoNonInvoicing = 'CO_NON_INVOICING',
  CoOrdinary = 'CO_ORDINARY',
  CoSimple = 'CO_SIMPLE',
  PeCompany = 'PE_COMPANY',
  PeNaturalPerson = 'PE_NATURAL_PERSON'
}

/** An enumeration. */
export enum TopSellersOrderByEnum {
  Amount = 'AMOUNT',
  Count = 'COUNT'
}

/** An enumeration. */
export enum TransitionAttribute {
  Commission = 'COMMISSION',
  Count = 'COUNT',
  Sales = 'SALES'
}

/** An enumeration. */
export enum TransitionOperator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE'
}

/** An enumeration. */
export enum TransitionPeriod {
  AllTime = 'ALL_TIME',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type UpdateCommunityPostInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredIcon?: InputMaybe<CommunityPostFeaturedIcon>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<CommunityPostMediaEntryInput>>;
  postId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreatorNotificationPreferenceInputType = {
  brandMessages?: InputMaybe<Scalars['Boolean']['input']>;
  campaignTypes?: InputMaybe<Array<CampaignTypeEnum>>;
  campaignsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  collabUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  grouping?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEligible?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  opportunities?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<Scalars['Boolean']['input']>;
  rewards?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDiscountCodeInputType = {
  brandId: Scalars['ID']['input'];
  discountCodes: Array<DiscountCodeEntryInputType>;
};

export type UpdateEventInput = {
  applicationMode?: InputMaybe<EventApplicationMode>;
  audienceAfiliateProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audienceAfiliateUserStatuses?: InputMaybe<Array<AfiliateUserStatus>>;
  audienceJoinedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ecommerceOfficeId?: InputMaybe<Scalars['ID']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventId: Scalars['ID']['input'];
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventTypeInput = {
  allowAdminInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  allowUserApplication?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  defaultApplicationMode?: InputMaybe<Scalars['String']['input']>;
  defaultDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventTypeId: Scalars['ID']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNotificationPreferenceInput = {
  marketingMailing: Scalars['Boolean']['input'];
  paymentsMailing: Scalars['Boolean']['input'];
  systemMailing: Scalars['Boolean']['input'];
};

export type UploadMediaDraftInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaType: DraftUploadMediaType;
  mimeType: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum UploadTimeframeOptions {
  Any = 'ANY',
  FirstWeekOfMonth = 'FIRST_WEEK_OF_MONTH',
  LastWeekOfMonth = 'LAST_WEEK_OF_MONTH',
  OnceAMonth = 'ONCE_A_MONTH',
  OnceAWeek = 'ONCE_A_WEEK'
}

/** An enumeration. */
export enum UserNicheKind {
  Link = 'LINK',
  Post = 'POST',
  Video = 'VIDEO'
}

export type UserObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UserPortfolioInput = {
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** An enumeration. */
export enum VariablePaymentType {
  ProductSales = 'PRODUCT_SALES',
  TotalSales = 'TOTAL_SALES',
  Traffic = 'TRAFFIC',
  Visits = 'VISITS'
}

/** An enumeration. */
export enum WalletTransactionStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum WalletWithdrawalInvoiceTypeEnum {
  HonorariosReceipt = 'HONORARIOS_RECEIPT',
  Invoice = 'INVOICE'
}

/**
 * Who produces the tax document a withdrawal needs, and how the creator
 * hands it in. The apps render the withdrawal flow by kind and never branch
 * on the country.
 */
export enum WithdrawalDocumentKindEnum {
  CreatorSigns = 'CREATOR_SIGNS',
  CreatorUploads = 'CREATOR_UPLOADS',
  MontuIssues = 'MONTU_ISSUES',
  NotSupported = 'NOT_SUPPORTED'
}

export type WithdrawalInput = {
  amount: MoneyInput;
  appLabel?: InputMaybe<Scalars['String']['input']>;
  bankAccountId: Scalars['String']['input'];
  invoiceFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Deprecated, removed next release: the document type is now derived from the wallet's tax regime. Ignored whenever a regime is known; kept only for clients that don't send `wallet_id` yet. */
  invoiceType?: InputMaybe<WalletWithdrawalInvoiceTypeEnum>;
  /** The wallet to withdraw from. Preferred over `invoice_type`: resolves the tax regime from the wallet, and must belong to the requesting user. */
  walletId?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum WorkOrderCancelReasonEnum {
  CreatorReported = 'CREATOR_REPORTED',
  NoPriceAgreement = 'NO_PRICE_AGREEMENT',
  NoResponseInTime = 'NO_RESPONSE_IN_TIME',
  Other = 'OTHER',
  SchedulesNotCompatible = 'SCHEDULES_NOT_COMPATIBLE',
  Suspension = 'SUSPENSION'
}

/** An enumeration. */
export enum WorkOrderPaymentMethodEnum {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Free = 'FREE',
  Wallet = 'WALLET'
}

export type WorkOrderPostulationInput = {
  amount: MoneyInput;
  contentRequirements: Array<ContentRequirementInput>;
  preselectionId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum WorkOrderStatusEnum {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  PendingPayment = 'PENDING_PAYMENT'
}

export type WorkspaceInputType = {
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  source: WorkspaceSourceEnum;
};

/** An enumeration. */
export enum WorkspaceSourceEnum {
  ClickFunnels = 'CLICK_FUNNELS',
  Google = 'GOOGLE',
  GuestStart = 'GUEST_START',
  LandingPage = 'LANDING_PAGE',
  Other = 'OTHER',
  Recommendation = 'RECOMMENDATION',
  SocialNetworks = 'SOCIAL_NETWORKS'
}
